let dpiScale = 1;               // 当前页面缩放比例
let maps = [];                  // 当前所有图件

const DOT_PER_INCH = 72;        // 默认 DPI
const INCH_TO_METER = 0.0254;   // 一英寸 = 0.0254 M
const TRACK_HEADER_HEIGHT = 32; // 默认 Header 高度
const FLT_EPSILON = 1e-2;       // 数值相等判断精度


// 数值相等判断
function flt_equal(a, b) {
    return Math.abs(a-b) <= FLT_EPSILON;
}

// 计算数值数量级
function calc_num_order(num) {
    return Math.floor(Math.log10(num));
}

const CurveScale = {
    TrackScale : 0,
    Linear : 1,
    Logarithmic : 2
}

const TrackScale = {
    Linear : 1,
    Logarithmic : 2
}

class Point{
    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }
}

class DepthRange{
    constructor(begin = 0, end = 0) {
        this.begin = begin;
        this.end = end;
    }

    GetThick(){
        return this.end - this.begin;
    }
}

function CenterPoint(pt1, pt2) {
    return new Point((pt1.x+pt2.x)/2, (pt1.y+pt2.y)/2);
}

function CalcParallelPos(pt0, pt1, ptStart, x) {
    let ptEnd = new Point(x, 0);
    if (flt_equal(pt0.x, pt1.x)) {
        ptEnd = (pt0.y+pt1.y)/2;
    } else {
        const k = (pt1.y - pt0.y) / (pt1.x - pt0.x);
        ptEnd.y = k * (ptEnd.x - ptStart.x) + ptStart.y;
    }
    return ptEnd;
}

// pt 绕 o 旋转 angle 弧度 逆时针
function RotatePoint(pt, o, angle)
{
    pt.x = (pt.x - o.x)*Math.cos(angle) - (pt.y - o.y)*Math.sin(angle) + o.x;
    pt.y = (pt.x - o.x)*Math.sin(angle) + (pt.y - o.y)*Math.cos(angle) + o.y;
}

function RotateLineCenter(pt1, pt2, angle)
{
    const center = CenterPoint(pt1, pt2);

    RotatePoint(pt1, center, angle);
    RotatePoint(pt2, center, angle);
}

// 两条直线计算交点
function LineInterSect(p1, p2, q1, q2, cross) {
    if ( flt_equal( p1.x, p2.x ) && flt_equal( q1.x, q2.x ) ) {
        //  两条垂线
        return false;
    } else if ( flt_equal( p1.x, p2.x ) && !flt_equal( q1.x, q2.x ) ) {
        //  p为垂线
        let dX = p1.x;
        let dY = ( q1.y - q2.y ) / ( q1.x - q2.x );
        dY = dY * ( p1.x - q1.x ) + q1.y;

        cross.x = dX;
        cross.y = dY;
    }
    else if ( !flt_equal( p1.x, p2.x ) && flt_equal( q1.x, q2.x ) ) {
        //  q为垂线
        let dX = q1.x;
        let dY = ( p1.y - p2.y ) / ( p1.x - p2.x );
        dY = dY * ( q1.x - p1.x ) + p1.y;

        cross.x = dX;
        cross.y = dY;
    } else {
        let dPK = ( p1.y - p2.y ) / ( p1.x - p2.x );
        let dQK = ( q1.y - q2.y ) / ( q1.x - q2.x );

        if ( flt_equal( dPK, dQK ) ) {
            //  平行或重合
            return false;
        }

        let dX = ( p1.y - dPK * p1.x - q1.y + dQK * q1.x ) / ( dQK - dPK );
        let dY = ( dX - p1.x ) * dPK + p1.y;

        cross.x = dX;
        cross.y = dY;
    }
    return true;
}

function GetFaciesColor(name)
{
    let clrLine;
    let clrFill;
    // if (name === "t1-1-1" || name === "t1-1-2")
    // {
    //     clrLine = 'Gray';
    //     clrFill = 'Red';
    // }
    // else if (name === "t1-1-3" || name === "t1-1-4")
    // {
    //     clrLine = 'Gray';
    //     clrFill = 'RGB(255,173,91)';
    // }
    // else if (name === "t1-1-5" || name === "t1-1-6")
    // {
    //     clrLine = 'Gray';
    //     clrFill = 'Lime';
    // }
    // else if (name === "t1-1-7" || name === "t1-1-8")
    // {
    //     clrLine = 'Gray';
    //     clrFill = 'Yellow';
    // }
    // else
    // {
    //     clrLine = 'Gray';
    //     clrFill = 'Sienna';
    // }

    if (name.indexOf("河道") !== -1)
    {
        clrLine = 'Gray';
        clrFill = 'Red';
    }
    else if (name.indexOf("表外") !== -1)
    {
        clrLine = 'Gray';
        clrFill = 'RGB(0,140,0)';
    }
    else if (name.indexOf("河间表内") !== -1 || name.indexOf("非主体薄层砂") !== -1)
    {
        clrLine = 'Gray';
        clrFill = 'Lime';
    }
    else if (name.indexOf("主体薄层砂") !== -1)
    {
        clrLine = 'Gray';
        clrFill = 'Yellow';
    }
    else
    {
        clrLine = 'Gray';
        clrFill = 'RGB(217,255,255)';
    }

    // console.log("GetFaciesColor ", name);
    return [clrLine, clrFill];
}

function MakeRect(pt1, pt2) {
    const left = Math.min(pt1.x, pt2.x);
    const top = Math.min(pt1.y, pt2.y);
    const right = Math.max(pt1.x, pt2.x);
    const bottom = Math.max(pt1.y, pt2.y);

    return new Rect(left, top, right-left, bottom-top);
}

class Rect {
    constructor(left, top, width, height) {
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }

    CenterPoint() {
        return new Point(this.left+this.width/2, this.top + this.height/2);
    }

    PtInRect(pt) {
        return this.left < pt.x && this.GetRight() > pt.x && this.top < pt.y && this.GetBottom() > pt.y;
    }

    GetLeft() {
        return this.left;
    }

    GetTop () {
        return this.top;
    }

    GetRight() {
        return this.left + this.width;
    }

    GetBottom() {
        return this.top + this.height;
    }

    OffsetRect(x, y) {
        this.left += x;
        this.top += y;
    }

    Center() {
        return new Point(this.left + this.width/2, this.top + this.height/2);
    }

    HasIntersection(rect) {
        const left = Math.max(this.left, rect.left);
        const top = Math.max(this.top, rect.top);
        const right = Math.min(this.GetRight(), rect.GetRight())
        const bottom = Math.min(this.GetBottom(), rect.GetBottom())
        return left < right && top < bottom;
    }

    InflateRect(x, y = undefined) {
        if ( y === undefined) {
            y = x;
        }
        this.left -=x;
        this.top -= y;
        this.width += x;
        this.height += y;
    }

    DeflateRect(x, y = undefined) {
        if ( y === undefined) {
            y = x;
        }
        this.InflateRect(-x, -y);
    }

    Clone() {
        return new Rect(this.left, this.top, this.width, this.height);
    }
}

class LogPoint{
    constructor(depth, value, nullVal = false) {
        this.depth = depth;
        this.value = value;
        this.null = nullVal;
    }
}

class LogCurve {
    constructor(name) {
        this.name = name;
        this.points = [];
        this.minValue = 0;
        this.maxValue = 0;
        this.minDepth = 0;
        this.maxDepth = 0;
    }

    StaticDataInfo() {
        if (this.points.length === 0) {
            this.minValue = 0;
            this.maxValue = 0;
            this.minDepth = 0;
            this.maxDepth = 0;
            return;
        }
        this.minValue = Number.MAX_VALUE;
        this.maxValue = -Number.MAX_VALUE;
        this.minDepth = this.points[0].depth;
        this.maxDepth = this.points[this.points.length-1].depth;

        for(let pt of this.points) {
            if (pt.null) {
                continue;
            }
            if (pt.value > this.maxValue) {
                this.maxValue = pt.value;
            }
            if (pt.value < this.minValue) {
                this.minValue = pt.value;
            }
        }
    }

    AddPoint(point) {
        this.points.push(point);
    }

    GetName() {
        return this.name;
    }

    GetPoints() {
        return this.points;
    }

    SetPoints(points) {
        this.points = points;
    }
}

class WellLogLinearConversion {
    constructor(leftValue, rightValue) {
        this.leftValue = leftValue;
        this.rightValue = rightValue;
        this.width = rightValue - leftValue;
        this.reciprocal = 1/this.width;
    }

    Convert(value) {
        return (value - this.leftValue) * this.reciprocal;
    }

    Reverse(value) {
        return value * this.width + this.leftValue;
    }
}

class WellLogLogarithmicConversion {
    constructor(leftValue, rightValue) {
        this.leftValue = Math.log10(leftValue);
        this.rightValue = Math.log10(rightValue);
        this.width = this.rightValue - this.leftValue;
        this.reciprocal = 1/this.width;
    }

    Convert(value) {
        return value <= 0 ? FLT_EPSILON : (Math.log10(value) - this.leftValue) * this.reciprocal;
    }

    Reverse(value) {
        return Math.pow(10, value * this.width + this.leftValue);
    }
}

class WellLogScaledData {
    constructor(logCurve, conversion) {
        this.logCurve = logCurve;
        this.conversion = conversion;
    }

    GetDataRange(begin, end) {
        let data = [];
        if(null == this.logCurve) {
            return data;
        }

        let start = false;
        let prevPoint = null;
        for(const logPoint of this.logCurve.points) {
            if (!start) {
                if (logPoint.depth >= begin && logPoint.depth <= end) {
                    start = true;
                    if (prevPoint != null) {
                        data.push(this.ConvertLogPoint(prevPoint));
                    }
                    data.push( this.ConvertLogPoint(logPoint) );
                } else {
                    prevPoint = logPoint;
                }
            } else {
                data.push(this.ConvertLogPoint(logPoint));
                if (logPoint.depth >= end) {
                    break;
                }
            }
        }
        return data;
    }

    ConvertLogPoint(point) {
        return new LogPoint(point.depth, this.conversion.Convert(point.value), point.null);
    }
}

// const COLOR_TABLE = ['Aqua',
// 'Bisque',
// 'CadetBlue',
// 'DarkOliveGreen',
// 'DarkSalmon',
// 'DarkSlateGray',
// 'GoldenRod',
// 'LightSalmon',
// 'Tan',
// 'Teal'];

class StratumData {
    constructor(dataName) {
        this.name = dataName;
        this.layers = [];
    }
}

class PerfData {
    constructor() {
        this.layers = [];
    }
}

class SymbolDataItemBase {
    constructor(parent, top, bottom, layer, name) {
        this.parent = parent;
        this.topDepth = top;
        this.botDepth = bottom;
        this.layer = layer;
        this.name = name;
        this.image = new Image();  
        this.loaded = false;
        // console.log("base", this.name);
    }

    Load(path) {
        const that = this;
        this.image.onload = function () {
            // console.log("Layer Loaded");
            that.loaded = true;
            that.parent.LayerLoaded();
        }
        this.image.src = `${path}/${this.name}.ico`;
        // console.log("image src1", this.image.src);
    }

    LoadCore(path) {
        const that = this;
        this.image.onload = function () {
            // console.log("Layer Loaded");
            that.loaded = true;
            that.parent.LayerLoaded();
        }
        this.image.src = `${path}/${this.core}.ico`;
        // console.log("image src", this.image.src);
    }
}

class StratumLayer extends SymbolDataItemBase{
    constructor(top, bottom, name, litho = '', core = '', refTop = 0, refBot = 0, stratum = '',parent = null) {
        super(parent, top, bottom, name, core);
        this.refrenceTop = refTop;
        this.refrenceBot = refBot;
        this.topDepth = top;
        this.botDepth = bottom;
        this.topY = 0;
        this.botY = 0;
        this.name = name;
        this.stratum = stratum;
        this.core = core;
        this.litho = litho;
        this.fillColor = "Transparent";
        if(core != null && core != undefined && core != "") this.LoadCore("../images/lithology");
    }
}

class LithoDataItem extends SymbolDataItemBase {
    constructor(parent, top, bottom, layer, name) {
        super(parent, top, bottom, layer, name);
        this.Load("../images/lithology");
    }
}

class SymbolDataItem extends SymbolDataItemBase {
    constructor(parent, top, bottom, layer, name) {
        super(parent, top, bottom, layer, name);
        this.Load("../images/symbol");
    }
}

class SymbolDataSet{
    constructor(type) {
        this.type = type;
        this.layers = [];
        this.observers = [];        
    }

    Attach(ob) {
        this.observers.push(ob);
    }

    Detach(ob) {
        for(const i in this.observers) {
            if (this.observers[i] === ob) {
                delete this.observers[i];
                break;
            }
        }
    }

    LayerLoaded() {
        let loaded = true;
        for(const layer of this.layers) {
            if (!layer.loaded) {
                loaded = false;
                break;
            }
        }
        // loaded = true;
        if (loaded) {
            for(const ob of this.observers) {
                ob.Update(this);
            }
        }
    }    
}

// 岩性或砂岩
class LithologyData extends SymbolDataSet{
    constructor() {
        super(LithoDataItem);
    }
}

// 解释
class SymbolData extends SymbolDataSet{
    constructor() {
        super(SymbolDataItem);
    }
}

// function base64ToFloat32Array(base64String) {
//     const rawData = Base64.decode(base64String);
//     const buffer = new ArrayBuffer(rawData.length);
//     const outputArray = new Uint8Array(buffer);
//     const floatView = new Float32Array(buffer);
//
//     for (let i = 0; i < rawData.length; ++i) {
//         outputArray[i] = rawData.charCodeAt(i);
//     }
//     return floatView;
// }

function base64ToFloat64Array(base64String) {
    const rawData = window.atob(base64String);
    const buffer = new ArrayBuffer(rawData.length);
    const outputArray = new Uint8Array(buffer);
    const floatView = new Float64Array(buffer);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return floatView;
}

class MapDataManager {
    constructor() {
        this.wells = [];
    }

    Parse(json) {
        this.wells = [];

        for(const wellData of json) {
            const well = new WellDataManager();
            well.Parse(wellData);
            this.wells.push(well);
        }
    }
}

class WellDataManager{
    constructor() {
        this.wellName = '';
        this.logCurves = [];
        this.stratumData = null;
        this.perfData = null;
        this.sandData = null;
        this.explainData = null;
    }

    AddCurve(curve) {
        this.logCurves.push(curve);
    }

    GetLogCurve(name) {
        let data = null;
        for(const curve of this.logCurves) {
            if (curve.name === name) {
                data = curve;
                break;
            }
        }
        return data;
    }

    GetPerfData() {
        return this.perfData;
    }

    GetSandData() {
        return this.sandData;
    }

    GetStratumData() {
        return this.stratumData;
    }

    GetExplainData() {
        return this.explainData;
    }

    Parse(json) {
        this.wellName = json.wellName;
        if (json.logCurve) {
            this.ParseLogcurve(json.logCurve);
        }
        if (json.stratum) {
            this.ParseStratum(json.stratum);
        }
        if (json.sand) {
            this.ParseSand(json.sand);
        }
        if (json.perf) {
            this.ParsePerf(json.perf);
        }
        if (json.explain) {
            this.ParseExplain(json.explain);
        }
    }

    ParseLogcurve(json) {
        for(const curve of json) {
            // console.log(curve);
            // const topDepth = Number.parseFloat(curve.TopDepth);
            // const botDepth = Number.parseFloat(curve.BotDepth);
            // const depthStep = Number.parseFloat(curve.DepthStep);
            const nullValue = Number.parseFloat(curve.nullValue);
            const valueArray = base64ToFloat64Array(curve.value);

            const curveData = new LogCurve(curve.name);
            // let depth = topDepth;
            for(let i = 0; i < valueArray.length; i+=2) {
                const depth0 = valueArray[i];
                const value0 = valueArray[i+1];
                curveData.AddPoint(new LogPoint(depth0, value0, flt_equal(value0, nullValue)));
                // depth += depthStep;
            }
            curveData.StaticDataInfo();
            this.AddCurve(curveData);
        }
    }

    ParseStratum(json) {
        this.stratumData = new StratumData('地层');
        for(const layer of json) {
            this.stratumData.layers.push(new StratumLayer(layer.topDepth, layer.botDepth, layer.name));
        }

        // TODO 原始数据未排序 排序后去除以下代码
        this.stratumData.layers.sort(function(a,b) {return a.topDepth - b.topDepth;});
    }

    ParsePerf(json) {
        this.perfData = new PerfData();
        for(const layer of json) {
            this.perfData.layers.push(new StratumLayer(layer.topDepth, layer.botDepth, layer.name));
        }
    }

    ParseSand(json) {
        // this.sandData = new LithologyData();
        // for(const layer of json) {
        //     this.sandData.layers.push(new LithoDataItem(this.sandData, layer.topDepth, layer.botDepth, layer.name, layer.litho));
        // }

        this.sandData = new SymbolData();
        for(const layer of json) {
            // TODO layer.litho 属性是错误的 暂时使用 layer.name 作为岩性
            // this.sandData.layers.push(new StratumLayer(layer.topDepth, layer.botDepth, layer.name, layer.name, layer.refTop, layer.refBot, layer.stratum));
            this.sandData.layers.push(new StratumLayer(layer.topDepth, layer.botDepth, layer.name, layer.litho, layer.core, layer.refTop, layer.refBot, layer.stratum,this.sandData));
        }

        // TODO 测试数据过于密集，跳过部分数据，正式数据时去掉
        // if (this.sandData.layers.length > 0) {
        //     this.sandData.layers.sort(function(a,b) {return a.topDepth - b.topDepth;});
        //     for(let i = this.sandData.layers.length-2; i >= 0; i-=2) {
        //         this.sandData.layers.splice(i, 1);
        //     }
        // }
    }

    ParseExplain(json) {
        this.explainData = new SymbolData();
        for(const layer of json) {
            this.explainData.layers.push(new SymbolDataItem(this.explainData, layer.topDepth, layer.botDepth, layer.name, layer.value));
        }
    }
}

// class Well{
//     constructor(name) {
//         this.name = name;
//         this.hzbx = 0;
//         this.zzby = 0;
//         this.dataMgr = new WellDataManager(name);
//     }
// }

class Header {
    constructor() {
        this.top = 0;
        this.height = TRACK_HEADER_HEIGHT;
        this.visible = true;
        this.showTitle = true;
        this.showBorder = false;
    }

    GetTop() {
        return this.top;
    }

    SetTop(top) {
        this.top = top;
    }

    GetBottom() {
        return this.top + this.height;
    }

    GetHeight() {
        return this.height;
    }

    SetHeight(height) {
        this.height = height;
    }

    IsVisible() {
        return this.visible;
    }

    SetVisible(visible) {
        this.visible = visible;
    }

    GetDesiredHeight() {
        if (!this.visible)
            return 0;
        return TRACK_HEADER_HEIGHT;
    }

    AdjustHeaderHeight() {
        this.height = TRACK_HEADER_HEIGHT;
    }
}

class CurveHeader extends Header {
    constructor(logCurve, curveTrackHeader) {
        super()
        this.logCurve = logCurve;
        this.trackHeader = curveTrackHeader;
        this.titleFont = "12px 宋体";
    }

    Draw(dp) {
        if (this.logCurve.logCurve === null)
            return;

        const ctx = dp.context;
        ctx.save();

        const track = this.logCurve.GetTrack();

        ctx.beginPath();
        ctx.rect(track.GetLeft(), this.top, track.GetWidth(), this.height);
        ctx.clip();

        ctx.font = this.titleFont;
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";

        const posY = this.top + this.height/2;

        ctx.fillStyle = "Black";
        ctx.fillText(this.logCurve.GetName(), track.GetLeft() + track.GetWidth()/2, posY);

        ctx.strokeStyle = this.logCurve.lineColor;
        ctx.lineWidth = this.logCurve.lineWidth;

        const MARGIN = 5;

        ctx.beginPath();
        ctx.moveTo(track.GetLeft() + MARGIN, 2 + posY);
        ctx.lineTo(track.GetRight() - MARGIN, 2 + posY);
        ctx.stroke();

        let leftValue = this.logCurve.GetLeftValue();
        let rightValue = this.logCurve.GetRightValue();

        if (this.logCurve.reverse) {
            [leftValue, rightValue] = [rightValue, leftValue];
        }

        ctx.textAlign = "left";
        ctx.fillText(leftValue.toFixed(1).replace(/\.0+/, ''), track.GetLeft() + MARGIN / 2, posY);

        ctx.textAlign = "right";
        ctx.fillText(rightValue.toFixed(1).replace(/\.0+/, ''), track.GetRight() - MARGIN / 2, posY);
        ctx.restore();

        if (this.showBorder) {
            this.DrawBorder(dp);
        }
        // this.DrawBorder(dp);
    }

    DrawBorder(dp) {
        const ctx = dp.context;
        ctx.save();
        ctx.strokeStyle = "#000000";
        ctx.lineWidth = 1;

        const track = this.logCurve.GetTrack();
        const well = track.GetWellDisplay();

        ctx.beginPath();
        ctx.moveTo(track.left, this.GetBottom());
        if (flt_equal(track.left, well.left)) {
            ctx.lineTo(track.left, this.top);
        } else {
            ctx.moveTo(track.left, this.top);
        }
        ctx.lineTo(track.right, this.top);
        ctx.lineTo(track.right, this.GetBottom());
        ctx.stroke();
        ctx.restore();
    }

    AdjustHeaderHeight() {
        if (null != this.trackHeader) {
            const count = this.trackHeader.GetVisibleHeaderCount();
            const height = this.trackHeader.GetHeight();
            if (count <= 1) {
                this.SetHeight(height);
            } else {
                this.SetHeight(height/count);
            }
        }
        else{
            this.SetHeight(TRACK_HEADER_HEIGHT);
        }
    }
}

class TrackHeader extends Header {
    constructor(track, stackedParentHeader) {
        super();
        this.track = track;
        this.titleFont = "14px 宋体";
        this.parentHeader = stackedParentHeader;
    }

    Draw(dp) {
        const ctx = dp.context;
        ctx.save();

        if (this.showBorder) {
            this.DrawBorder(dp);
        }
        // this.DrawBorder(dp);

        if (this.showTitle) {
            this.DrawTitle(dp);
        }
        ctx.restore();
    }

    DrawBorder(dp) {
        const ctx = dp.context;
        ctx.strokeStyle = "#000000";
        ctx.lineWidth = 1;

        const well = this.track.GetWellDisplay();

        ctx.beginPath();
        ctx.moveTo(this.track.left, this.GetBottom());

        if (flt_equal(this.track.left, well.left)) {
            ctx.lineTo(this.track.left, this.top);
        } else {
            ctx.moveTo(this.track.left, this.top);
        }
        ctx.lineTo(this.track.right, this.top);
        ctx.lineTo(this.track.right, this.GetBottom());
        ctx.stroke();
    }

    DrawTitle(dp) {
        const ctx = dp.context;
        ctx.font = this.titleFont;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "Black";
        ctx.fillText(this.track.GetTitle(), this.track.GetLeft() + this.track.GetWidth()/2, this.top+this.height/2);
    }

    AdjustLayout() {
        this.AdjustHeaderHeight();
    }

    AdjustHeaderHeight() {
        if (null != this.parentHeader) {
            const childHeight = this.parentHeader.GetChildHeight();
            this.SetHeight(childHeight);
        }
        else{
            this.SetHeight(TRACK_HEADER_HEIGHT);
        }
    }
}

class StackedHeaderBase extends TrackHeader {
    constructor(track, stackedParentHeader) {
        super(track, stackedParentHeader);
        this.headers = [];
    }

    Draw(dp) {
        for(let header of this.headers) {
            header.Draw(dp);
        }
    }

    AddHeader(header) {
        this.headers.push(header);
    }

    GetHeaderCount() {
        return this.Headers.length;
    }

    GetHeaders() {
        return this.headers;
    }

    GetVisibleHeaderCount() {
        let count = 0;
        for(let header of this.headers) {
            if (header.visible)
                count += 1;
        }
        return count;
    }

    AdjustHeaderHeight() {
        super.AdjustHeaderHeight();

       for(let header of this.headers) {
           header.AdjustHeaderHeight();
       }
    }
}

class StackedTrackHeader extends StackedHeaderBase {
    constructor(track, stackedParentHeader) {
        super(track, stackedParentHeader);
        this.titleHeight = 50;
        // this.showTitle = true;
    }

    Draw(dp) {
        super.Draw(dp);

        if (this.showTitle) {
            const ctx = dp.context;                
            ctx.save();

            ctx.font = this.titleFont;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "Black";
            ctx.fillText(this.track.GetTitle(), this.track.GetLeft() + this.track.GetWidth()/2, this.top+this.titleHeight/2);

            ctx.restore();
        }

        if (this.showBorder) {
            this.DrawBorder(dp);
        }
        // this.DrawBorder(dp);
    }

    GetDesiredHeight() {
        if (!this.visible)
            return 0;
        
        let maxHeight = TRACK_HEADER_HEIGHT;
        for(let header of this.headers) {
            const height = header.GetDesiredHeight();
            if (height > maxHeight)
                maxHeight = height;
        }

        let desiredHeight = maxHeight;
        if (this.showTitle)
            desiredHeight += this.titleHeight;
        return desiredHeight;
    }
    
    AdjustLayout() {
        const desiredHeight = this.GetDesiredHeight();
        if (this.height < desiredHeight) {
            this.SetHeight(desiredHeight);
        }

        let top = 0;
        if(this.parentHeader instanceof StackedTrackHeader)
        {
            top = this.parentHeader.top;
            if (this.parentHeader.showTitle)
                top += this.parentHeader.titleHeight;
        }
        this.top = top;

        const childTop = this.showTitle ? this.top + this.titleHeight : this.top;
        const childHeight = this.GetBottom() - childTop;
        for(let header of this.headers) {
            header.top = childTop;
            header.height = childHeight;
            header.AdjustLayout();
        }
    }

    GetChildHeight() {
        let height = this.height;
        if (this.showTitle)
            height -= this.titleHeight;
        return height;
    }
}

class CurveTrackHeader extends StackedHeaderBase {
    constructor(track, stackedParentHeader) {
        super(track, stackedParentHeader);
    }
    
    GetDesiredHeight() {
        if (!this.visible)
            return 0;

        return TRACK_HEADER_HEIGHT * this.GetVisibleHeaderCount();
    }

    AdjustHeaderHeight() {
        super.AdjustHeaderHeight();

        let top = this.top;
        for(let header of this.headers) {
            header.top = top;
            top = header.GetBottom();
        }
    }
}

class WellLogFill{
    constructor(track, refSource, refTarget) {
        this.track = track;
        this.refSource = refSource;
        this.refTarget = refTarget;
        this.fillLeft = refSource.fillLeft;
        this.leftFillColor = refSource.leftFillColor;
        this.fillRight = refSource.fillRight;
        this.rightFillColor = refSource.rightFillColor;
    }

    Draw(dp, top, bot) {
        const topDepth = this.track.ViewToDepth(this.track.top);
        const botDepth = this.track.ViewToDepth(this.track.bottom);

        const minDepth = Math.max(topDepth, top);
        const maxDepth = Math.min(botDepth, bot);

        let refSourcePoints = this.GetRefDataPoints(this.refSource, minDepth, maxDepth);
        let refTargetPoints = [];

        if (refSourcePoints.length === 0) {
            return;
        }

        if (this.refSource.fillTargetType === 1) {
            if (this.fillLeft) {
                refTargetPoints = [new LogPoint(minDepth, 0), new LogPoint(maxDepth, 0)];
                this.DrawFill(dp, top, bot, refSourcePoints, refTargetPoints, this.leftFillColor, "left");
            }
            if (this.fillRight) {
                refTargetPoints = [new LogPoint(minDepth, 1), new LogPoint(maxDepth, 1)];
                this.DrawFill(dp, top, bot, refSourcePoints, refTargetPoints, this.rightFillColor, "right");
            }
        } else {
            if (this.refSource.fillTargetType === 2) {
                let rightValue = this.refSource.conversion.Convert(this.refTarget);
                refTargetPoints.push(new LogPoint(minDepth, rightValue));
                refTargetPoints.push(new LogPoint(maxDepth, rightValue));
            } else {
                refTargetPoints = this.GetRefDataPoints(this.refTarget, minDepth, maxDepth);
            }

            if (this.fillLeft) {
                this.DrawFill(dp, top, bot, refSourcePoints, refTargetPoints, this.leftFillColor, "left");
            }
            if (this.fillRight) {
                this.DrawFill(dp, top, bot, refSourcePoints, refTargetPoints, this.rightFillColor, "right");
            }
        }
    }

    DrawFill(dp, top, bot, srcPoints, targetPoints, fillStyle, fillSide) {
        const topDepth = this.track.ViewToDepth(this.track.top);
        const minDepth = Math.max(topDepth, top);
        const minViewDepth = this.track.DepthToView(minDepth);

        const ctx = dp.context;
        ctx.save();

        // if (targetPoints.length > 0) {
            // clip
            ctx.beginPath();

            const clipXPos = fillSide === "left" ? this.track.left : this.track.right;
            let lastPosY = minViewDepth;

            ctx.moveTo(clipXPos, minViewDepth);
            for (const point of srcPoints) {
                const depth = point.depth;
                const value = point.value;

                const posX = value * this.track.GetWidth() + this.track.left;
                const posY = this.track.DepthToView(depth);
                lastPosY = posY;
                ctx.lineTo(posX, posY);
            }
            ctx.lineTo(clipXPos, lastPosY);
            ctx.closePath();
            ctx.clip();
        // }

        // fill
        ctx.beginPath();

        let firstPoint = true;
        for(const point of srcPoints) {
            const depth = point.depth;
            const value = point.value;

            const posX = value * this.track.GetWidth() + this.track.left;
            const posY = this.track.DepthToView(depth);

            if (firstPoint) {
                firstPoint = false;
                ctx.moveTo(posX, posY);
            } else{
                ctx.lineTo(posX, posY);
            }
        }

        if (targetPoints.length > 0) {
            for(let i = targetPoints.length-1; i >= 0; i--) {
                const point = targetPoints[i];

                const depth = point.depth;
                const value = point.value;

                const posX = value * this.track.GetWidth() + this.track.left;
                const posY = this.track.DepthToView(depth);
                ctx.lineTo(posX, posY);
            }
        }

        ctx.closePath();
        ctx.fillStyle = fillStyle;
        ctx.fill();
        ctx.restore();
    }

    GetRefDataPoints(refData, topDepth, bottomDepth) {
        return refData.scaledData.GetDataRange(topDepth, bottomDepth)
    }
}

class WellLogCurve{
    constructor(track, curveName, template = null) {
        this.track = track;
        this.logCurve = track.GetWellDisplay().GetData().GetLogCurve(curveName);
        if (this.logCurve) {
            this.leftValue= this.logCurve.minValue;
            this.rightValue = this.logCurve.maxValue;
        }
        this.header = new CurveHeader(this, track.GetHeader());
        this.scale = CurveScale.TrackScale;

        this.conversion = null;
        this.scaledData = null;
        this.reverse = false;

        this.Init(template);
    }

    Init(template) {

        this.lineColor = "#ff0000";
        this.lineWidth = 1;

        if (template) {
            this.lineColor = template.lineColor;
            this.lineWidth = template.lineWidth;
            this.header.titleFont = template.titleFont;
            this.header.showBorder = template.showHeaderBorder;
            this.autoValue = template.autoValue;
            this.reverse = template.reverse;

            if (!this.autoValue) {
                this.leftValue = template.leftValue;
                this.rightValue = template.rightValue;
            }

            // Fill
            this.showFill = template.showFill;
            this.fillTargetType = template.fillTargetType;
            this.fillTargetValue = template.fillTargetValue;
            this.fillTargetCurve = template.fillTargetCurve;
            this.fillLeft = template.fillLeft;
            this.leftFillColor = template.leftFillColor;
            this.fillRight = template.fillRight;
            this.rightFillColor = template.rightFillColor;

            // TODO template.curveScale
        }
    }

    Draw(dp, top, bot) {
        if (!this.scaledData) {
            return;
        }

        const ctx = dp.context;
        ctx.save();

        const topDepth = this.track.ViewToDepth(this.track.top);
        const botDepth = this.track.ViewToDepth(this.track.bottom);

        const minDepth = Math.max(topDepth, top);
        const maxDepth = Math.min(botDepth, bot);

        const scaledPoint = this.scaledData.GetDataRange(minDepth, maxDepth);

        let firstPoint = true;
        ctx.strokeStyle = this.lineColor;
        ctx.lineWidth = this.lineWidth;
        ctx.beginPath();
        for(const point of scaledPoint) {
            const depth = point.depth;
            const value = point.value;

            const posX = value * (this.track.right - this.track.left) + this.track.left;
            const posY = this.track.DepthToView(depth);

            if (firstPoint) {
                firstPoint = false;
                ctx.moveTo(posX, posY);
            } else{
                ctx.lineTo(posX, posY);
            }
        }

        ctx.stroke();
        ctx.restore();
    }

    IsLogScale() {
        let logScale;
        if (this.scale === CurveScale.TrackScale) {
            logScale = this.track.scale === TrackScale.Logarithmic;
        } else {
            logScale = this.scale === CurveScale.Logarithmic;
        }
        return logScale;
    }

    GetHeader() {
        return this.header;
    }

    GetTrack() {
        return this.track;
    }

    GetName() {
        if (!this.logCurve) {
            return "";
        }
        return this.logCurve.GetName();
    }

    GetLogCurve() {
        return this.logCurve;
    }

    GetLeftValue() {
        return this.leftValue;
    }

    GetRightValue() {
        return this.rightValue;
    }

    UpdateData() {
        if (!this.logCurve) {
            this.scaledData = null;
            this.conversion = null;
            return;
        }
        if (this.IsLogScale()) {
            let leftValue = this.leftValue;
            let rightValue = this.rightValue;

            if (flt_equal(leftValue, 0) || leftValue < 0) {
                leftValue = 1;
            }
            if (flt_equal(rightValue, 0) || rightValue < 0) {
                rightValue = leftValue * 100;
            }
            if (this.reverse) {
                [leftValue, rightValue] = [rightValue, leftValue]
            }
            this.conversion = new WellLogLogarithmicConversion(leftValue, rightValue);
        } else {
            let leftValue = this.leftValue;
            let rightValue = this.rightValue;

            if (this.reverse) {
                [leftValue, rightValue] = [rightValue, leftValue]
            }
            this.conversion = new WellLogLinearConversion(leftValue, rightValue);
        }
        this.scaledData = new WellLogScaledData(this.logCurve, this.conversion);
    }

    GetDepthRange() {
        if (null === this.logCurve) {
            return [0,0];
        }
        return [this.logCurve.minDepth, this.logCurve.maxDepth];
    }
}

class WellLogTrack {
    constructor(parent) {
        this.parent = parent;
        this.left = 0;
        this.right = 80;
        this.top = 50;
        this.bottom = 500;
        // this._showBorder = true;
        this.leftBorder = true;
        this.rightBorder = true;
        this.topBorder = true;
        this.bottomBorder = true;
        this.title = "";
        this.header = null;
        this.depthScale = 300;  // 深度比例
        this.minDepth = 87;      // 显示深度范围
        this.maxDepth = 500;   // 显示深度范围
    }

    // get showBorder() {
    //     return this._showBorder;
    // }
    //
    // set showBorder(show) {
    //     this._showBorder = show;
    // }

    Init(template) {
        if (template) {
            if (this.header) {
                this.header.showTitle = template.showTitle;
                this.header.titleFont = template.titleFont;
                this.header.showBorder = template.showHeaderBorder;
            }

            // this._showBorder = template.showBorder;
            this.leftBorder = template.leftBorder;
            this.rightBorder = template.rightBorder;
            this.topBorder = template.topBorder;
            this.bottomBorder = template.bottomBorder;

            this.SetTitle(template.title);
            this.SetWidth(template.trackWidth);
        }
        this.UpdateDepthRange();
    }

    DrawBorder(dp) {
        const ctx = dp.context;
        ctx.strokeStyle = "#000000";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(this.left, this.top);

        // const well = this.GetWellDisplay();

        if (this.leftBorder) {
            ctx.lineTo(this.left, this.bottom);
        } else {
            ctx.moveTo(this.left, this.bottom);
        }
        if (this.bottomBorder) {
            ctx.lineTo(this.right, this.bottom);
        } else {
            ctx.moveTo(this.right, this.bottom);
        }

        if (this.rightBorder) {
            ctx.lineTo(this.right, this.top);
        } else {
            ctx.moveTo(this.right, this.top);
        }

        if (this.topBorder) {
            ctx.lineTo(this.left, this.top);
        } else {
            ctx.moveTo(this.left, this.top);
        }
        // if (flt_equal(this.left, well.left)) {
        //     ctx.lineTo(this.left, this.bottom);
        // } else {
        //     ctx.moveTo(this.left, this.bottom);
        // }
        // ctx.lineTo(this.right, this.bottom);
        // ctx.lineTo(this.right, this.top);
        // ctx.lineTo(this.left, this.top);

        ctx.stroke();
    }

    SetTitle(title) {
        this.title = title;
    }

    GetTitle() {
        return this.title;
    }

    GetHeader() {
        return this.header;
    }

    SetWidth(width) {
        this.right = this.left + width;
    }

    GetWidth() {
        return this.right - this.left;
    }

    GetHeight() {
        let height = this.GetBodyHeight();
        if (this.header) {
            height += this.header.GetHeight();
        }
        return height;
    }

    GetBodyHeight() {
        return this.bottom - this.top;
    }

    GetLeft() {
        return this.left;
    }

    GetRight() {
        return this.right;
    }

    GetTop() {
        return this.top;
    }

    GetBottom() {
        return this.bottom;
    }

    DepthToView(depth) {
        return Math.ceil(this.top + (depth - this.minDepth) * DOT_PER_INCH / INCH_TO_METER / this.depthScale);
    }

    ViewToDepth(pos) {
        return (pos - this.top) / (DOT_PER_INCH / INCH_TO_METER / this.depthScale) + this.minDepth;
    }

    AdjustLayout() {
        if (this.parent == null) {
            return;
        }
        
        let left = this.parent.GetLeft();
        this.top = this.parent.GetTop();
        this.bottom = this.parent.GetBottom();

        for( const track of this.parent.GetTracks()) {
            if (this === track)
                break;
            left += track.GetWidth();
        }
        const width = this.GetWidth();
        this.left = left;
        this.right = this.left + width;
    }

    GetWellDisplay() {
        let parent = this;
        while(parent != null) {
            const t = parent.parent;
            if (t == null)
                break;
            parent = t;
        }
        return parent;
    }

    UpdateDepthRange() {
        this.minDepth = 0;
        this.maxDepth = 0;
    }

    GetDepthRange() {
        return [this.minDepth, this.maxDepth];
    }
}

class LogCurveTrack extends WellLogTrack{
    constructor(parent, title, template = null) {
        super(parent);

        this.title = title;
        this.curves = [];
        this.fills = [];
        this.minorTickStep = 2;
        this.majorTickStep = 10;

        this.header = new CurveTrackHeader(this, parent.GetHeader());
        this.Init(template);
    }

    // get showBorder() {
    //     return this._showBorder;
    // }
    //
    // set showBorder(show) {
    //     this._showBorder = show;
    //
    //     for(const curve of this.curves) {
    //         curve.header.showBorder = show;
    //     }
    // }

    Init(template) {
        // 刻度
        this.minorValueTickColor = "LightGray";
        this.majorValueTickColor = "DimGray";
        this.minorDepthTickColor = "LightGray";
        this.majorDepthTickColor = "DimGray";

        this.showMinorValueTick = false;
        this.showMajorValueTick = false;
        this.showMinorDepthTick = false;
        this.showMajorDepthTick = false;
        this.minorTickCount = 10;
        this.majorTickCount = 2;

        // this.scale = TrackScale.Logarithmic;
        this.scale = TrackScale.Linear;

        if (template) {
            this.showMinorValueTick = template.showMinorValueGrid;
            this.showMajorValueTick = template.showMajorValueGrid;
            this.showMinorDepthTick = template.showMinorDepthGrid;
            this.showMajorDepthTick = template.showMajorDepthGrid;

            this.minorTickCount = template.minorTickCount;
            this.majorTickCount = template.majorTickCount;
            this.minorTickStep = template.minorDepthStep;
            this.majorTickStep = template.majorDepthStep;

            this.minorValueTickColor = template.minorValueTickColor;
            this.majorValueTickColor = template.majorValueTickColor;
            this.minorDepthTickColor = template.minorDepthTickColor;
            this.majorDepthTickColor = template.majorDepthTickColor;
            this.scale = template.trackScale === "Linear" ? TrackScale.Linear : TrackScale.Logarithmic;

            for(const logCurve of template.children) {
                this.AddLogCurve(new WellLogCurve(this, logCurve.curveName, logCurve));
            }

            // Fills
            for(const curve of this.curves) {
                if (!curve.scaledData) {
                    continue;
                }
                if (curve.fillLeft || curve.fillRight) {
                    this.fills.push(this.CreateFill(curve));
                }
            }
        }
        super.Init(template);
    }

    CreateFill(curve) {
        let refSource = curve;
        let refTarget = null;

        if (curve.fillTargetType === 1) {
            refTarget = 0;
        } else if (curve.fillTargetType === 2) {
            refTarget = curve.fillTargetValue;
        } else {
            for(const curve0 of this.curves) {
                if (curve0 !== curve) {
                    refTarget = curve0;
                }
            }
        }
        return new WellLogFill(this, refSource, refTarget);
    }

    Draw(dp, minDepth, maxDepth) {
        const ctx = dp.context;
        ctx.save();

        // if (this.showBorder) {
        //     this.DrawBorder(dp);
        // }
        this.DrawBorder(dp);

        ctx.beginPath();
        ctx.rect(this.GetLeft(), this.GetTop(), this.GetWidth(), this.GetBodyHeight());
        ctx.clip();

        this.DrawGrid(dp, minDepth, maxDepth);
        this.DrawFills(dp, minDepth, maxDepth);
        this.DrawCurves(dp, minDepth, maxDepth);

        ctx.restore();
    }

    DrawCurves(dp, minDepth, maxDepth) {
        for(const curve of this.curves) {
            curve.Draw(dp, minDepth, maxDepth);
        }
    }

    DrawFills(dp, minDepth, maxDepth) {
        for(const fill of this.fills) {
            fill.Draw(dp, minDepth, maxDepth);
        }
    }

    DrawGrid(dp) {
        if (this.showMinorValueTick) {
            this.DrawMinorValueGrid(dp);
        }
        if (this.showMajorValueTick) {
            this.DrawMajorValueGrid(dp);
        }

        if (this.showMinorDepthTick) {
            this.DrawMinorDepthGrid(dp);
        }
        if (this.showMajorDepthTick) {
            this.DrawMajorDepthGrid(dp);
        }
    }

    DrawMinorValueGrid(dp) {
        const ctx = dp.context;
        const top = this.DepthToView(this.minDepth);
        const bottom = this.DepthToView(this.maxDepth);

        ctx.lineWidth = 1;
        ctx.strokeStyle = this.minorValueTickColor;

        if (this.scale === TrackScale.Linear) {
            if (this.minorTickCount > 0) {
                const tickStep = this.GetWidth() / (this.minorTickCount);
                for(let i = 1; i < this.minorTickCount; i++) {
                    const pos = this.left + tickStep * i;
                    ctx.beginPath();
                    ctx.moveTo(pos, top);
                    ctx.lineTo(pos, bottom);
                    ctx.stroke();
                }
            }
        } else {
            let leftValue = this.GetLeftValue();
            let rightValue = this.GetRightValue();

            const reverse = leftValue > rightValue;
            let minValue = Math.min(leftValue, rightValue);
            let maxValue = Math.max(leftValue, rightValue);

            if (flt_equal(0, minValue) || minValue < 0) {
                minValue = 1;
            }
            if (flt_equal(minValue, maxValue) || maxValue < minValue) {
                maxValue = 100 * minValue;
            }

            const minOrder = calc_num_order(minValue);
            const maxOrder = calc_num_order(maxValue);

            const startVal = Math.pow(10, minOrder) * (Math.floor(minValue/Math.pow(10, minOrder) + 1));
            const stopVal = Math.pow(10, maxOrder) * (Math.floor(maxValue/Math.pow(10, maxOrder)));

            const minValueLog = Math.log10(minValue);
            const maxValueLog = Math.log10(maxValue);

            const offsetFactor = reverse ? -1 : 1;
            const offsetFactor2 = reverse ? 1 : 0;

            let valueTicks = [];
            if (flt_equal(minOrder, maxOrder)) {
                let tempVal = startVal;
                let logValue = 0;
                while (tempVal <= stopVal) {
                    logValue = offsetFactor2 + offsetFactor * (Math.log10(tempVal) - minValueLog) / (maxValueLog - minValueLog);
                    valueTicks.push(logValue);

                    tempVal += Math.pow(10, minOrder);
                }
            } else {
                let tempVal = startVal;
                let logValue = 0;

                while (tempVal < Math.pow(10, minOrder+1)) {
                    logValue = offsetFactor2 + offsetFactor * (Math.log10(tempVal) - minValueLog) / (maxValueLog - minValueLog);
                    valueTicks.push(logValue);

                    tempVal += Math.pow(10, minOrder);
                }

                const n = maxOrder - minOrder;
                if (n > 1) {
                    // let stepTemp = Math.pow(10, minOrder+1);
                    for(let i = 1; i < n; i++) {
                        tempVal = Math.pow(10, minOrder+i);
                        for(let j = 0; j < 10; j++) {
                            logValue = offsetFactor2 + offsetFactor * (Math.log10(tempVal) - minValueLog) / (maxValueLog - minValueLog);
                            valueTicks.push(logValue);

                            tempVal += Math.pow(10, minOrder+i);
                        }
                        // stepTemp *= 10;
                    }
                }

                tempVal = Math.pow(10, maxOrder);
                while (tempVal <= stopVal) {
                    logValue = offsetFactor2 + offsetFactor * (Math.log10(tempVal) - minValueLog) / (maxValueLog - minValueLog);
                    valueTicks.push(logValue);

                    tempVal += Math.pow(10, maxOrder);
                }
            }

            for(const valueTick of valueTicks) {
                const pos = Math.floor(this.left + this.GetWidth() * valueTick);
                ctx.beginPath();
                ctx.moveTo(pos, top);
                ctx.lineTo(pos, bottom);
                ctx.stroke();
            }
        }
    }

    DrawMajorValueGrid(dp) {
        const ctx = dp.context;
        const top = this.DepthToView(this.minDepth);
        const bottom = this.DepthToView(this.maxDepth);

        ctx.lineWidth = 1;
        ctx.strokeStyle = this.majorValueTickColor;

        if (this.scale === TrackScale.Linear) {
            if (this.majorTickCount > 0) {
                const tickStep = this.GetWidth() / (this.majorTickCount);
                for(let i = 1; i < this.majorTickCount; i++) {
                    const pos = this.left + tickStep * i;
                    ctx.beginPath();
                    ctx.moveTo(pos, top);
                    ctx.lineTo(pos, bottom);
                    ctx.stroke();
                }
            }
        } else {

            let leftValue = this.GetLeftValue();
            let rightValue = this.GetRightValue();

            const reverse = leftValue > rightValue;
            let minValue = Math.min(leftValue, rightValue);
            let maxValue = Math.max(leftValue, rightValue);

            if (flt_equal(0, minValue) || minValue < 0) {
                minValue = 1;
            }
            if (flt_equal(minValue, maxValue) || maxValue < minValue) {
                maxValue = 100 * minValue;
            }

            const minOrder = calc_num_order(minValue);
            const maxOrder = calc_num_order(maxValue);

            const startVal = Math.pow(10, minOrder) * (Math.floor(minValue/Math.pow(10, minOrder) + 1));
            // const stopVal = Math.pow(10, maxOrder) * (Math.floor(maxValue/Math.pow(10, maxOrder)));

            const minValueLog = Math.log10(minValue);
            const maxValueLog = Math.log10(maxValue);

            const offsetFactor = reverse ? -1 : 1;
            const offsetFactor2 = reverse ? 1 : 0;

            let tempVal = startVal;
            let logValue = 0;

            let valueTicks = [];
            const n = maxOrder - minOrder;
            if (n > 1) {
                for(let i = 1; i < n; i++) {
                    tempVal = Math.pow(10, minOrder+i);
                    logValue = offsetFactor2 + offsetFactor * (Math.log10(tempVal) - minValueLog) / (maxValueLog - minValueLog);
                    valueTicks.push(logValue);
                }
            }

            for(const valueTick of valueTicks) {
                const pos = Math.floor(this.left + this.GetWidth() * valueTick);
                ctx.beginPath();
                ctx.moveTo(pos, top);
                ctx.lineTo(pos, bottom);
                ctx.stroke();
            }
        }
    }

    DrawMinorDepthGrid(dp) {
        const ctx = dp.context;
        // const wellDisplay = this.GetWellDisplay();

        ctx.lineWidth = 1;
        ctx.strokeStyle = this.minorDepthTickColor;

        const step = this.minorTickStep;

        const minDepth = Math.floor(this.minDepth / step) * step;
        const maxDepth = Math.ceil(this.maxDepth / step) * step;

        let depth = minDepth;
        while (depth < maxDepth) {
            const posY = this.DepthToView(depth);

            ctx.beginPath();
            ctx.moveTo(this.left, posY);
            ctx.lineTo(this.right, posY);
            ctx.stroke();
            depth += step;
        }
    }

    DrawMajorDepthGrid(dp) {
        const ctx = dp.context;
        // const wellDisplay = this.GetWellDisplay();

        ctx.lineWidth = 1;
        ctx.strokeStyle = this.majorDepthTickColor;

        const step = this.majorTickStep;
        const minDepth = Math.floor(this.minDepth / step) * step;
        const maxDepth = Math.ceil(this.maxDepth / step) * step;

        let depth = minDepth;
        while (depth < maxDepth) {
            const posY = this.DepthToView(depth);

            ctx.beginPath();
            ctx.moveTo(this.left, posY);
            ctx.lineTo(this.right, posY);
            ctx.stroke();
            depth += step;
        }
    }

    GetLeftValue() {
        let leftValue = Number.MAX_VALUE;
        for(const curve of this.curves) {
            if (curve.IsLogScale()) {
                if (curve.leftValue < leftValue) {
                    leftValue = curve.leftValue;
                }
            }
        }
        if (flt_equal(leftValue, Number.MAX_VALUE)) {
            leftValue = 1;
        }
        return leftValue;
    }

    GetRightValue() {
        let rightValue = -Number.MAX_VALUE;
        for(const curve of this.curves) {
            if (curve.IsLogScale()) {
                if (curve.rightValue > rightValue) {
                    rightValue = curve.rightValue;
                }
            }
        }
        if (flt_equal(rightValue, -Number.MAX_VALUE)) {
            rightValue = 1000;
        }
        return rightValue;
    }

    AddLogCurve(curve) {
        this.curves.push(curve);
        this.header.AddHeader(curve.GetHeader());

        curve.UpdateData();
    }

    AddLogFill(fill) {
        this.fills.push(fill);
    }

    AdjustLayout() {
        super.AdjustLayout();
    }

    UpdateDepthRange() {
        this.minDepth = 0;
        this.maxDepth = 0;

        const count = this.curves.length;
        if (count === 0) {
            return;
        }

        this.minDepth = Number.MAX_VALUE;
        this.maxDepth = -Number.MAX_VALUE;

        for(const curve of this.curves) {
            let [minDepth, maxDepth] = curve.GetDepthRange();
            if (minDepth < this.minDepth) {
                this.minDepth = minDepth;
            }
            if (maxDepth > this.maxDepth) {
                this.maxDepth = maxDepth;
            }
        }
    }
}

class StratumTrack extends WellLogTrack {
    constructor(parent, title='地层', template = null) {
        super(parent);

        this.SetTitle(title);
        this.header = new TrackHeader(this, this.parent.GetHeader());
        this.Init(template);
    }

    Init(template) {
        this.SetWidth(50);
        if (this.title === '地层') {
            this.data = this.GetWellDisplay().GetData().GetStratumData();
        } else {
            this.data = this.GetWellDisplay().GetData().GetSandData();
        }
        this.showLabel = true;
        this.labelFont = "12px 宋体";

        super.Init(template);
    }

    Draw(dp, minDepth, maxDepth) {
        this.DrawStratum(dp, minDepth, maxDepth);

        // if (this.showBorder) {
        //     this.DrawBorder(dp);
        // }
        this.DrawBorder(dp);
    }

    DrawStratum(dp, minDepth, maxDepth) {
        // console.log("welllDisplayInit",minDepth,maxDepth,dp)
        if (null === this.data) {
            return;
        }

        const ctx = dp.context;
        ctx.save();

        ctx.beginPath();
        ctx.rect(this.left, this.top, this.GetWidth(), this.GetBodyHeight());
        ctx.clip();
        ctx.lineWidth = 1;

        for(const layer of this.data.layers) {
            const topDepth = layer.topDepth;
            const botDepth = layer.botDepth;

            if (botDepth < minDepth) {
                continue;
            }
            if (topDepth > maxDepth) {
                break;
            }

            const top = Math.floor(this.DepthToView(topDepth));
            const bottom = Math.ceil(this.DepthToView(botDepth));

            // console.log("stratum", top, bottom, this.top, this.bottom);

            if (bottom < this.top) {
                continue;
            }
            if (top > this.bottom) {
                break;
            }

            // console.log("--------stratum draw--------");
            // console.log(layer);

            ctx.fillStyle = layer.fillColor;
            ctx.fillRect(this.left, top, this.GetWidth(), bottom - top);

            ctx.font = this.labelFont;
            ctx.fillStyle = "Black";
            ctx.textAlign = "center";
            ctx.textBaseline = "center";
            ctx.fillText(layer.name, this.left + this.GetWidth()/2, (bottom + top) / 2);

            // ctx.strokeStyle = 'LightGray';
            // ctx.beginPath();
            // ctx.moveTo(this.left, top);
            // ctx.lineTo(this.right, top);
            // ctx.moveTo(this.left, bottom);
            // ctx.lineTo(this.right, bottom);
            // ctx.stroke();
        }
        ctx.restore();
    }

    UpdateDepthRange() {
        this.minDepth = 0;
        this.maxDepth = 0;

        if (null == this.data) {
            return;
        }

        const count = this.data.layers.length;
        if (count === 0) {
            return;
        }

        this.minDepth = this.data.layers[0].topDepth;
        this.maxDepth = this.data.layers[count-1].botDepth;
    }
}

class SandTrack extends WellLogTrack {
    constructor(parent, title, template = null) {
        super(parent);

        this.SetTitle(title);
        this.header = new TrackHeader(this, this.parent.GetHeader());

        this.Init(template);
    }

    Init(template) {

        this.SetWidth(50);

        const wellData = this.GetWellDisplay().GetData();
        if (this.title === "砂岩") {
            this.data = wellData.GetSandData();
        } else if (this.title === "解释") {
            this.data = wellData.GetExplainData();
            if(this.data!=null && this.data != undefined) this.data.Attach(this);
        } else {
            // TODO 砂岩道数据
            this.data = new LithologyData();
        }

        super.Init(template);
    }

    Update(data) {
        if (data === this.data) {
            this.GetWellDisplay().GetParentMap().Refresh();
        }
    }

    Draw(dp, minDepth, maxDepth) {
        // if (this.showBorder) {
        //     this.DrawBorder(dp);
        // }
        this.DrawBorder(dp);

        this.DrawSands(dp, minDepth, maxDepth);
    }

    DrawSands(dp, minDepth, maxDepth) {
        if (null === this.data) {
            return;
        }

        const ctx = dp.context;
        ctx.save();

        ctx.beginPath();
        ctx.rect(this.left, this.top, this.GetWidth(), this.GetBodyHeight());
        ctx.clip();

        for(const sand of this.data.layers) {
            const topDepth = sand.topDepth;
            const botDepth = sand.botDepth;

            if (botDepth < minDepth) {
                continue;
            }
            if (topDepth > maxDepth) {
                break;
            }

            const top = Math.floor(this.DepthToView(topDepth));
            const bottom = Math.ceil(this.DepthToView(botDepth));

            if (bottom < this.top) {
                continue;
            }
            if (top > this.bottom) {
                break;
            }

            if (sand.loaded) {
                ctx.save();
                ctx.translate(this.left, top);
                ctx.translate(-0.5, -0.5);

                let width = this.GetWidth();
                let height = bottom - top;
                ctx.beginPath();
                ctx.rect(0, 0, width, height);
                ctx.clip();

                let count = Math.max(Math.round(height / sand.image.height), 1);
                let ratio = 1;
                if (height < sand.image.height) {
                    ratio = height / (count * sand.image.height);
                }

                let imageHeightTotal = count * sand.image.height * ratio;
                let topOffset = (height - imageHeightTotal) / 2;
                // let leftOffset = (width - sand.image.width) / 2;

                let topPos = topOffset;
                for(let i = 0; i < count; i++) {
                    ctx.drawImage(sand.image, 0, topPos, sand.image.width, sand.image.height*ratio);
                    topPos += sand.image.height*ratio;
                }

                // ctx.fillStyle = ctx.createPattern(sand.image, 'repeat');
                // ctx.fillRect(0, 0, this.GetWidth(), bottom - top);
                // ctx.drawImage(sand.image, 0, 0, this.GetWidth(), bottom - top)
                ctx.restore();
            }
        }

        ctx.restore();
    }

    UpdateDepthRange() {
        this.minDepth = 0;
        this.maxDepth = 0;

        if (null == this.data) {
            return;
        }

        const count = this.data.layers.length;
        if (count === 0) {
            return;
        }

        this.minDepth = this.data.layers[0].topDepth;
        this.maxDepth = this.data.layers[count-1].botDepth;
    }
}

class PerfTrack extends WellLogTrack {
    constructor(parent, title, template) {
        super(parent);

        this.SetTitle(title);
        this.header = new TrackHeader(this, this.parent.GetHeader());
        this.Init(template);
    }

    Init(template) {
        this.data = this.GetWellDisplay().GetData().GetPerfData();
        this.SetWidth(50);

        this.showLabel = false;
        this.labelSize = 12;
        this.labelColor = "Black";
        this.symbolColor = "Black";

        if (template) {
            this.showLabel = template.showLabel;
            this.labelSize = template.labelSize;
            this.labelColor = template.labelColor;
            this.symbolColor = template.symbolColor;
        }

        super.Init(template);
    }

    Draw(dp, minDepth, maxDepth) {
        // if (this.showBorder) {
        //     this.DrawBorder(dp);
        // }
        this.DrawBorder(dp);

        this.DrawPerfs(dp, minDepth, maxDepth);
    }

    DrawPerfs(dp, minDepth, maxDepth) {
        if (null === this.data) {
            return;
        }

        const ctx = dp.context;
        ctx.save();

        ctx.beginPath();
        ctx.rect(this.left, this.top, this.GetWidth(), this.GetBodyHeight());
        ctx.clip();

        ctx.lineWidth = 1;
        ctx.strokeStyle = this.symbolColor;
        ctx.fillStyle = this.labelColor;
        ctx.font = this.labelSize + "px 宋体";
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";

        const margin = this.GetWidth() * 0.38;
        const left = this.left + margin;
        const right = this.right - margin;
        const center = (left + right) / 2;

        ctx.beginPath();

        for(const layer of this.data.layers) {
            const topDepth = layer.topDepth;
            const botDepth = layer.botDepth;

            if (botDepth < minDepth) {
                continue;
            }
            if (topDepth > maxDepth) {
                break;
            }

            const top = Math.floor(this.DepthToView(topDepth));
            const bottom = Math.ceil(this.DepthToView(botDepth));

            if (bottom < this.top) {
                continue;
            }
            if (top > this.bottom) {
                break;
            }

            // 绘制射孔厚度
            if (this.showLabel) {
                const thick = botDepth-topDepth;
                ctx.fillText(thick.toFixed(1).replace(/\.0+/, ''), center, (top+bottom)/2);
            }

            // 绘制工字型射孔符号
            ctx.moveTo(left, top);
            ctx.lineTo(right, top);
            // ctx.stroke();

            // ctx.beginPath();
            ctx.moveTo(left, bottom);
            ctx.lineTo(right, bottom);
            // ctx.stroke();

            // ctx.beginPath();
            ctx.moveTo(center, top);
            ctx.lineTo(center, bottom);
            // ctx.stroke();
        }
        ctx.stroke();

        ctx.restore();
    }

    UpdateDepthRange() {
        this.minDepth = 0;
        this.maxDepth = 0;

        if (null == this.data) {
            return;
        }

        const count = this.data.layers.length;
        if (count === 0) {
            return;
        }

        this.minDepth = this.data.layers[0].topDepth;
        this.maxDepth = this.data.layers[count-1].botDepth;
    }
}

class DepthTrack extends WellLogTrack {
    constructor(parent, title, template = null) {
        super(parent);

        this.minorTickStep = 2;
        this.majorTickStep = 10;
        this.labelStep = 10;

        this.SetTitle(title);
        this.header = new TrackHeader(this, this.parent.GetHeader());

        this.Init(template);
    }

    Init(template) {
        this.showMinorTick = true;
        this.minorTickLength = 0.15;
        this.minorTickColor = "Gray";

        this.showMajorTick = true;
        this.majorTickLength = 0.2;
        this.majorTickColor = "DarkGray";

        this.showLabel = true;
        this.labelFont = "10px 宋体";
        this.labelColor = "Black";
        this.SetWidth(50);

        if (template) {
            this.minorTickStep = template.minorDepthStep;
            this.majorTickStep = template.majorDepthStep;
            this.labelStep = template.tickLabelStep;

            this.showMinorTick = template.showMinorTick;
            this.showMajorTick = template.showMajorTick;

            this.minorTickColor = template.minorTickColor;
            this.majorTickColor = template.majorTickColor;

            this.showLabel = template.showTickLabel;
        }
        super.Init(template);
    }

    Draw(dp, minDepth, maxDepth) {
        this.DrawBody(dp, minDepth, maxDepth);

        // if (this.showBorder) {
        //     this.DrawBorder(dp);
        // }
        this.DrawBorder(dp);
    }

    DrawBody(dp, top, bot) {
        const ctx = dp.context;
        ctx.save();

        ctx.beginPath();
        ctx.rect(this.GetLeft(), this.GetTop(), this.GetWidth(), this.GetBodyHeight());
        ctx.clip();

        const topDepth = Math.max(top, this.minDepth);
        const botDepth = Math.min(bot, this.maxDepth);

        if (this.showMinorTick) {
            ctx.strokeStyle = this.minorTickColor;
            ctx.lineWidth = 1;
            const step = this.minorTickStep;

            const minDepth = Math.floor(topDepth / step) * step;
            const maxDepth = Math.ceil(botDepth / step) * step;

            this.DrawTicks(dp, minDepth, maxDepth, step, this.minorTickLength, true);
        }

        if (this.showMajorTick) {
            ctx.strokeStyle = this.majorTickColor;
            ctx.lineWidth = 1;
            const step = this.majorTickStep;

            const minDepth = Math.floor(topDepth / step) * step;
            const maxDepth = Math.ceil(botDepth / step) * step;

            this.DrawTicks(dp, minDepth, maxDepth, step, this.majorTickLength, true);
        }

        if (this.showLabel) {
            ctx.fillStyle = "Black";
            ctx.font = this.labelFont;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";

            const step = this.labelStep;
            const minDepth = Math.floor(topDepth / step) * step;
            const maxDepth = Math.ceil(botDepth / step) * step;

            this.DrawTicks(dp, minDepth, maxDepth, step, this.majorTickLength, false, true);
        }
        ctx.restore();
    }

    DrawTicks(dp, beginDepth, endDepth, depthStep, tickLength, darwTick, drawLabel) {
        const ctx = dp.context;
        let depth = beginDepth;
        ctx.beginPath();

        const lineLength = this.GetWidth() * tickLength;
        while (depth <= endDepth) {
            const posY = this.DepthToView(depth);

            if (posY < this.top) {
                depth += depthStep;
                continue;
            }

            if (posY > this.bottom) {
                break;
            }

            if (darwTick) {
                ctx.moveTo(this.left, posY);
                ctx.lineTo(this.left + lineLength, posY);

                ctx.moveTo(this.right, posY);
                ctx.lineTo(this.right - lineLength, posY);
            }

            if (drawLabel) {
                ctx.fillText(depth.toString(), this.left + this.GetWidth()/2, posY);
            }

            depth += depthStep;
        }
        ctx.stroke();
    }
}

class StackedTrack extends WellLogTrack {
    constructor(parent) {
        super(parent);

        this.tracks = [];
        this.header = new StackedTrackHeader(this, parent ? parent.GetHeader() : null);
    }

    Draw(dp, minDepth, maxDepth) {
        for(let track of this.tracks) {
            track.Draw(dp, minDepth, maxDepth);
        }
    }

    AddTrack(track) {
        this.tracks.push(track);
        this.GetHeader().AddHeader(track.GetHeader());
    }

    GetTrackCount() {
        return this.tracks.length;
    }

    GetTracks() {
        return this.tracks;
    }

    AdjustLayout() {
        super.AdjustLayout();
        const count = this.tracks.length;
        if (count > 0) {
            for(const track of this.tracks) {
                track.top = this.top;
                track.AdjustLayout();
            }
            this.right = this.tracks[count-1].right;
        }
    }
}

// class Segment {
//     constructor() {
//         this.name = '';
//         this.text = '';
//         this.top = 0;
//         this.bottom = 0;
//         this.refrenceTop = 0;
//         this.topY = 0;
//         this.botY = 0;
//     }
// }

class SegmentSet {
    constructor(name, well) {
        this.name = name;
        this.well = well;
        this.segments = [];
        this.segTop = 0;
        this.segBot = 0;
    }

    CalsPos() {
        const wellPos = this.well.GetWellPos();
        for(const seg of this.segments) {
            seg.topY = this.well.DepthToView(seg.topDepth) + wellPos.y;
            seg.botY = this.well.DepthToView(seg.botDepth) + wellPos.y;
        }
    }

    GetRect() {
        const wellPos = this.well.GetWellPos();
        const left = this.well.GetLeft() + wellPos.x;
        const width = this.well.GetWidth();
        let top = Number.MAX_SAFE_INTEGER;
        let bot = -Number.MAX_SAFE_INTEGER;

        if (this.segments.length > 0) {
            for(const seg of this.segments) {
                const topY = seg.topY;
                const botY = seg.botY;

                if (topY < top) {
                    top = topY
                }
                if (botY > bot) {
                    bot = botY;
                }
            }
        }

        return new Rect(left, top, width, bot - top);
    }

    GetTop() {
        if (this.segments.length === 0) {
            return 0;
        }
        return this.segments[0].topY;
    }

    GetBot() {
        if (this.segments.length === 0) {
            return 0;
        }
        return this.segments[this.segments.length-1].topY;
    }
}


class LinkPolygon {
    constructor(points, brush) {
        this.points = points;
        this.brush = brush;
    }
}

class LinkPolyline {
    constructor(points, pen) {
        this.points = points;
        this.pen = pen;
    }
}

class LinkFill{
    constructor(fill, borders) {
        this.fill = fill;
        this.borders = borders;
    }
}

class LinkVisual {
    constructor() {
        this.fills = [];
        this.lines = [];
    }

    AddFill(fill) {
        this.fills.push(fill);
    }

    AddLine(line) {
        this.lines.push(line);
    }

    Draw(dp) {
        const ctx = dp.context;
        ctx.save();

        for(const fill of this.fills) {
            const polygon = fill.fill;
            if (polygon.points.length > 0) {
                ctx.beginPath();
                let first = true;
                for(const pt of polygon.points) {
                    if (first){
                        first = false;
                        ctx.moveTo(pt.x, pt.y);
                    } else {
                        ctx.lineTo(pt.x, pt.y);
                    }
                }
                ctx.fillStyle = polygon.brush;
                ctx.fill();
            }
        }

        ctx.lineCap = 'square';
        ctx.lineWidth = 1;

        for(const fill of this.fills) {
            for(const border of fill.borders) {
                let first = true;
                ctx.beginPath();
                for(const pt of border.points) {
                    if (first){
                        first = false;
                        ctx.moveTo(pt.x, pt.y);
                    } else {
                        ctx.lineTo(pt.x, pt.y);
                    }
                }
                ctx.strokeStyle = border.pen;
                ctx.stroke();
            }
        }

        for(const line of this.lines) {
            let first = true;
            ctx.beginPath();
            for(const pt of line.points) {
                if (first){
                    first = false;
                    ctx.moveTo(pt.x, pt.y);
                } else {
                    ctx.lineTo(pt.x, pt.y);
                }
            }
            ctx.strokeStyle = line.pen;
        }
        ctx.stroke();
        ctx.restore();
    }
}

// 一组井间连通
class SegmentLink {
    constructor(name, src = null, tar = null, pinchLength= 2) {
        this.name = name;
        this.srcSeg = src;              // SegmentSet
        this.tarSeg = tar;              // SegmentSet
        this.pinchLength = pinchLength; // 序号从 1 开始，1/2 1/4 1/3 Lh/H Lh/(h+1)
        this.visual = new LinkVisual();
    }

    Draw(dp) {
        const ctx = dp.context;
        ctx.save();

        if (this.IsPinch()) {
            this.UpdatePinchVisual();
        } else {
            this.UpdateLinkVisual();
        }
        this.visual.Draw(dp);
        ctx.restore();
    }

    IsPinch() {
        return this.srcSeg.segments.length === 0 || this.tarSeg.segments.length === 0;
    }

    CalcPinchFactor() {
        // 1/2 1/4 1/3 Lh/H Lh/(h+1)
        let pinchFactor = 1/4;
        const segPinch = this.srcSeg.segments.length > 0 ? this.srcSeg : this.tarSeg;

        const stratumLayer = segPinch.segments[0];
        const sandThick = stratumLayer.botDepth - stratumLayer.topDepth;
        const stratumThick = stratumLayer.refrenceBot - stratumLayer.refrenceTop;

        switch (this.pinchLength) {
            case 1:
                pinchFactor = 1/2;
                break;
            case 2:
                pinchFactor = 1/4;
                break;
            case 3:
                pinchFactor = 1/3;
                break;
            case 4:
                pinchFactor = sandThick/stratumThick;
                break;
            case 5:
                pinchFactor = sandThick/(sandThick+1);
                break;
        }
        return pinchFactor;
    }

    UpdatePinchVisual() {
        this.visual.fills = [];
        this.visual.lines = [];

        this.srcSeg.CalsPos();
        this.tarSeg.CalsPos();

        const rectSrc = this.srcSeg.GetRect();
        const rectTar = this.tarSeg.GetRect();

        let setLeft;
        let setRight;

        let rectLeft;
        let rectRight;

        if (rectSrc.GetLeft() + rectSrc.GetRight() < rectTar.GetLeft() + rectTar.GetRight()) {
            setLeft = this.srcSeg;
            setRight = this.tarSeg;

            rectLeft = rectSrc;
            rectRight = rectTar;
        } else {
            setLeft = this.tarSeg;
            setRight = this.srcSeg;

            rectLeft = rectTar;
            rectRight = rectSrc;
        }

        let lineColor, fillColor;
        let ptTop, ptBottom;

        const isLeft = setLeft.segments.length > 0;
        if (isLeft) {
            [lineColor, fillColor] = GetFaciesColor(setLeft.segments[0].litho);
            ptTop = new Point(rectLeft.CenterPoint().x, rectLeft.GetTop());
            ptBottom = new Point(rectLeft.CenterPoint().x, rectLeft.GetBottom());
        } else {
            [lineColor, fillColor] = GetFaciesColor(setRight.segments[0].litho);
            ptTop = new Point(rectRight.CenterPoint().x, rectRight.GetTop());
            ptBottom = new Point(rectRight.CenterPoint().x, rectRight.GetBottom());
        }

        const leftCenter = setLeft.well.DepthToView((setLeft.segTop+setLeft.segBot)/2) + setLeft.well.posY;
        const rightCenter = setRight.well.DepthToView((setRight.segTop+setRight.segBot)/2) + setRight.well.posY;

        const ptLC = new Point(rectLeft.CenterPoint().x, leftCenter);
        const ptRC = new Point(rectRight.CenterPoint().x, rightCenter);

        let xPos;
        // const PINCH_TYPE = 4;
        let pinchFactor = this.CalcPinchFactor();

        if (isLeft) {
            xPos = rectLeft.CenterPoint().x + (rectRight.CenterPoint().x - rectLeft.CenterPoint().x) * pinchFactor;
        } else {
            xPos = rectRight.CenterPoint().x - (rectRight.CenterPoint().x - rectLeft.CenterPoint().x) * pinchFactor;
        }

        const ptCenter = CenterPoint(ptTop, ptBottom);
        const ptPinch = CalcParallelPos(ptLC, ptRC, ptCenter, xPos);

        const points = [ptTop, ptPinch, ptBottom];

        const fill = new LinkPolygon(points, fillColor);
        const border = new LinkPolyline(points, lineColor);

        this.visual.AddFill(new LinkFill(fill, [border]));
    }

    UpdateLinkVisual() {
        this.visual.fills = [];
        this.visual.lines = [];

        this.srcSeg.CalsPos();
        this.tarSeg.CalsPos();

        const rectSrc = this.srcSeg.GetRect();
        const rectTar = this.tarSeg.GetRect();

        let setLeft;
        let setRight;

        let rectLeft;
        let rectRight;

        if (rectSrc.GetLeft() + rectSrc.GetRight() < rectTar.GetLeft() + rectTar.GetRight()) {
            setLeft = this.srcSeg;
            setRight = this.tarSeg;

            rectLeft = rectSrc;
            rectRight = rectTar;
        } else {
            setLeft = this.tarSeg;
            setRight = this.srcSeg;

            rectLeft = rectTar;
            rectRight = rectSrc;
        }

        const left = rectLeft.GetRight();
        const right = rectRight.GetLeft();

        let ptLT = new Point(rectLeft.CenterPoint().x, rectLeft.GetTop());
        let ptLB = new Point(rectLeft.CenterPoint().x, rectLeft.GetBottom());
        let ptRT = new Point(rectRight.CenterPoint().x, rectRight.GetTop());
        let ptRB = new Point(rectRight.CenterPoint().x, rectRight.GetBottom());

        // 中线
        let ptLCenter = CenterPoint(ptLT, ptLB);
        let ptRCenter = CenterPoint(ptRT, ptRB);

        let ptSplitTop = Object.assign({}, ptLCenter);
        let ptSplitBot = Object.assign({}, ptRCenter);


        const PI45 = Math.PI/4;
        const angle = ptRCenter.y < ptLCenter.y ? -PI45 : PI45;
        RotateLineCenter(ptSplitTop, ptSplitBot, angle);

        // 右侧一半向左延伸两个像素，避免出现接缝
        let ptSplitTop1 = new Point(ptSplitTop.x-2, ptSplitTop.y);
        let ptSplitBot1 = new Point(ptSplitBot.x-2, ptSplitBot.y);

        // 计算上下交点
        let crossUp = new Point();
        let crossDown = new Point();

        let crossUp1 = new Point();
        let crossDown1 = new Point();

        LineInterSect(ptLT, ptRT, ptSplitTop, ptSplitBot, crossUp);
        LineInterSect(ptLB, ptRB, ptSplitTop, ptSplitBot, crossDown);

        LineInterSect(ptLT, ptRT, ptSplitTop1, ptSplitBot1, crossUp1);
        LineInterSect(ptLB, ptRB, ptSplitTop1, ptSplitBot1, crossDown1);

        if (crossUp.x < left || crossUp.x > right || crossDown.x < left || crossDown.x > right) {
            crossUp = CenterPoint(ptLT, ptRT);
            crossDown = CenterPoint(ptLB, ptRB);

            crossUp1 = CenterPoint(ptLT, ptRT);
            crossDown1 = CenterPoint(ptLB, ptRB);
        }

        this.MakeStraightHalfLink(setLeft, crossUp, crossDown);
        this.MakeStraightHalfLink(setRight, crossUp1, crossDown1);
    }

    MakeStraightHalfLink(segSet, crossUp, crossDown) {
        const rectBody = segSet.GetRect();
        const xPos = rectBody.CenterPoint().x;

        let layers = [];
        for(const seg of segSet.segments) {
            layers.push(new DepthRange(seg.topY, seg.botY));
        }

        const splitPoints = this.CalcLineSplitPosNoGap(crossUp, crossDown, layers);
        console.assert(layers.length === splitPoints.length, '连通绘制数据运算错误，分层数与交点数不一致！');

        const fills = [];
        let ptPrev = crossUp;
        for(let i = 0; i < Math.min(layers.length, splitPoints.length); i++) {
            const ptCurrent = splitPoints[i];
            const seg = segSet.segments[i];

            const linkPoints = [new Point(xPos, seg.topY), ptPrev, ptCurrent, new Point(xPos, seg.botY)];

            let [lineColor, fillColor] = GetFaciesColor(seg.litho);

            const polygon = new LinkPolygon(linkPoints, fillColor);

            const borders = [];
            const border1 = new LinkPolyline([linkPoints[0], ptPrev], lineColor);
            const border2 = new LinkPolyline([linkPoints[linkPoints.length-1], ptCurrent], lineColor);
            borders.push(border1);
            borders.push(border2);

            const fill = new LinkFill(polygon, borders);
            fills.push(fill);
            this.visual.AddFill(fill);
            ptPrev = ptCurrent;
        }
        return fills;
    }

    CalcLineSplitPosNoGap(ptBegin, ptEnd, layers) {
        let points = [];
        let thickAll = 0;
        for(const layer of layers) {
            thickAll += layer.GetThick();
        }

        let thickAdd = 0;
        for(const layer of layers) {
            const thick = layer.GetThick();
            thickAdd += thick;
            const percent = thickAdd / thickAll;

            const x = (ptEnd.x - ptBegin.x) * percent + ptBegin.x;
            const y = (ptEnd.y - ptBegin.y) * percent + ptBegin.y;
            points.push(new Point(x, y));
        }
        return points;
    }

    SetLink(src, tar) {
        this.srcSeg = src;
        this.tarSeg = tar;
    }

    GetSrcWell() {
        return this.srcSeg.well;
    }

    GetTarWell() {
        return this.tarSeg.well;
    }

    GetSrcSegments() {
        return this.srcSeg.segments;
    }

    GetTarSegments() {
        return this.tarSeg.segments;
    }

    SortBy() {
        const srcTop = this.srcSeg.well.GetWellPos().y;
        const tarTop = this.tarSeg.well.GetWellPos().y;
        return (srcTop + tarTop)/2;
    }

    GetRect() {
        this.srcSeg.CalsPos();
        this.tarSeg.CalsPos();

        const rectSrc = this.srcSeg.GetRect();
        const rectTar = this.tarSeg.GetRect();

        let rectLeft;
        let rectRight;

        if (rectSrc.GetLeft() + rectSrc.GetRight() < rectTar.GetLeft() + rectTar.GetRight()) {
            rectLeft = rectSrc;
            rectRight = rectTar;
        } else {
            rectLeft = rectTar;
            rectRight = rectSrc;
        }

        const left = Math.min(rectLeft.GetRight(), rectRight.GetLeft());
        const right = Math.max(rectLeft.GetRight(), rectRight.GetLeft());
        const top = Math.min(rectLeft.GetTop(), rectRight.GetTop());
        const bottom = Math.max(rectLeft.GetBottom(), rectRight.GetBottom());
        return new Rect(left, top, right-left, bottom-top);
    }
}

// 井柱内的连通
class WellLinkGroup {
    constructor(wellDisplay) {
        this.well = wellDisplay;
        this.links = [];
        this.segments =[];      // StratumLayer
    }

    Draw(dp) {
        const ctx = dp.context;
        ctx.save();

        const top = this.well.top;
        const bottom = this.well.bottom;

        ctx.beginPath();
        for(const seg of this.segments) {

            if (seg.topY < top) {
                continue;
            }
            if (seg.botY > bottom) {
                break;
            }

            const [lineColor, fillColor]  = GetFaciesColor(seg.litho);
            ctx.strokeStyle = lineColor;
            ctx.fillStyle = fillColor;

            // ctx.fillRect(0, seg.topY, this.well.right, seg.botY - seg.topY);
            ctx.fillRect(-1, seg.topY, this.well.right+2, seg.botY - seg.topY);

            ctx.moveTo(0, seg.topY);
            ctx.lineTo(this.well.right, seg.topY);

            ctx.moveTo(0, seg.botY);
            ctx.lineTo(this.well.right, seg.botY);
        }

        ctx.stroke();
        ctx.restore();
    }

    ClearAll() {
        this.links = [];
        this.segments = [];
    }

    AddLink(link) {
        this.links.push(link);
    }

    UpdateSegments() {
        this.segments = [];
        for(const link of this.links) {
            if (link.GetSrcWell() === this.well) {
                this.AddSegments(link.GetSrcSegments());
            } else if (link.GetTarWell() === this.well) {
                this.AddSegments(link.GetTarSegments());
            }
        }
    }

    AddSegments(segments) {
        for(const seg of segments) {
            if (this.HasSegments(seg)) {
                continue;
            }
            // seg.topY = this.well.DepthToView(seg.topDepth);
            // seg.botY = this.well.DepthToView(seg.botDepth);
            // this.segments.push(seg);

            let segNew = Object.assign({}, seg);
            segNew.topY = this.well.DepthToView(seg.topDepth);
            segNew.botY = this.well.DepthToView(seg.botDepth);
            this.segments.push(segNew);
        }
    }

    HasSegments(segment) {
        let found = false;
        for(const seg of this.segments) {
            if (seg.name === segment.name
                && flt_equal(seg.topDepth, segment.topDepth)
                && flt_equal(seg.botDepth, segment.botDepth)) {
                found = true;
                break;
            }
        }
        return found;
    }
}

const TrackClasses = {
    DepthTrack,
    LogCurveTrack,
    StratumTrack,
    PerfTrack,
    SandTrack
}

class WellDisplay extends StackedTrack {
    constructor(data, template = null) {
        super(null);
        this.map = null;
        this.posX = 100;
        this.posY = 30;
        // this.minorTickStep = 2;
        // this.majorTickStep = 10;
        this.linkGourp = new WellLinkGroup(this);
        this.data = data;
        this.SetTitle(this.data.wellName);

        this.Init(template);
    }

    Init(template) {
        if (template) {
            // this._showBorder = template.showBorder;
            // this.minorTickStep = template.minorDepthStep;
            // this.majorTickStep = template.majorDepthStep;
            this.header.showTitle = template.showTitle;
            this.header.showBorder = template.showBorder;
            this.header.titleFont = template.titleFont;
            this.depthScale = template.depthScale;

            // this.minDepth = Number.MAX_VALUE;
            // this.maxDepth = -Number.MAX_VALUE;
            // 如果 template.depthType === 1 根据分层数据获取顶底深
            this.minDepth = template.topDepth;
            this.maxDepth = template.botDepth;

            const statumData = this.data.GetStratumData();
            if (template.depthType === 1 && statumData && statumData.layers.length > 0) {
                this.minDepth = statumData.layers[0].topDepth;
                this.maxDepth = statumData.layers[statumData.layers.length-1].botDepth;
            }

            for(const trackTemp of template.children) {
                const track = this.CreateTrack(trackTemp);
                if (track) {
                    // let [minDepth, maxDepth] = track.GetDepthRange();
                    // if (!flt_equal(minDepth, maxDepth)) {
                    //     if (minDepth < this.minDepth) {
                    //         this.minDepth = minDepth;
                    //     }
                    //     if (maxDepth > this.maxDepth) {
                    //         this.maxDepth = maxDepth;
                    //     }
                    // }

                    track.depthScale = this.depthScale;
                    // track.showBorder = this.showBorder;
                    // track.header.showBorder = this.header.showBorder;
                    this.AddTrack(track);
                }
            }

            this.bottom = this.DepthToView(this.maxDepth);
            for(const track of this.tracks) {
                track.top = this.top;
                track.bottom = this.bottom;
                track.minDepth = this.minDepth;
                track.maxDepth = this.maxDepth;
            }
        }
    }

    CreateTrack(trackTemp) {
        let track = null;
        const trackType = trackTemp.type;
        if (trackType in TrackClasses) {
            track = new TrackClasses[trackType](this, trackTemp.title, trackTemp);
        }
        return track;
    }

    Draw(dp, rect) {
        dp.context.save();

        dp.context.translate(this.posX, this.posY);

        const minDepth = this.ViewToDepth(rect.top);
        const maxDepth = this.ViewToDepth(rect.GetBottom());

        for(const track of this.tracks) {
            track.Draw(dp, minDepth, maxDepth);
        }
        
        if( this.header != null) {
            this.header.Draw(dp);
        }

        dp.context.restore();
    }

    DrawLink(dp) {
        dp.context.save();
        dp.context.translate(this.posX, this.posY);
        this.linkGourp.Draw(dp);
        dp.context.restore();
    }

    GetMinorTickStep() {
        return this.minorTickStep;
    }

    GetMajorTickStep() {
        return this.majorTickStep;
    }

    SetWellPos(x, y) {
        this.posX = x;
        this.posY = y;
    }

    GetWellPos() {
        return new Point(this.posX, this.posY);
    }

    GetRect() {
        let headerHeight = 0;
        if (this.header)
            headerHeight = this.header.height;

        const left = this.posX;
        const top = this.GetTop() + this.posY - headerHeight;
        const bottom = this.GetBottom() + this.posY;

        const count = this.GetTrackCount();
        const right = this.tracks[count - 1].GetRight() + this.posX;

        return new Rect(left, top, right - left, bottom - top);
    }

    HitTest(x, y) {
        return this.GetRect().PtInRect(new Point(x, y));
    }

    AdjustLayout() {
        if (this.header != null) {
            this.header.AdjustLayout();
            this.top = this.header.height;
        }

        super.AdjustLayout();
    }

    SetParentMap(map) {
        this.map = map;
    }

    GetParentMap() {
        return this.map;
    }

    // GetSandData() {
    //     let data = null;
    //     for(const track of this.tracks) {
    //         if (track instanceof StratumTrack) {
    //             if (track.title.indexOf('砂岩') === 0) {
    //                 data = track.data;
    //                 break;
    //             }
    //         }
    //     }
    //     return data;
    // }
    //
    // GetStratumData() {
    //     let data = null;
    //     for(const track of this.tracks) {
    //         if (track instanceof StratumTrack) {
    //             if (track.title.indexOf('地层') === 0) {
    //                 data = track.data;
    //                 break;
    //             }
    //         }
    //     }
    //     return data;
    // }

    GetLinkGroup() {
        return this.linkGourp;
    }

    GetData() {
        return this.data;
    }
}


class MapBase {
    constructor(root) {
        this.root = root;
        this.layers = [];
        this.wellDisplays = [];
        this.currentWell = null;
        this.moveBegin = null;
        this.movePrev = null;
        this.mouseDown = false;

        this.zoomBegin = null;
        this.zoomEnd = null;

        this.userInfoFont = "20px 宋体";
        this.editUser = 'XXX';
        this.makeUser = 'XXX';
        this.verifyUser = 'XXX';
        this.title = "XX油田XX井组柱状图";
        this.titleFont = "30px 隶书";
        this.borderLineWidth = 2;

        this.leftMargin = 10;
        this.topMargin = 50;
        this.bottomMargin = 50;
        this.rightMargin = 10;

        this._showLegend = true;
        this._showConnect = true;

        this.zoomRect = false;
        this.wellPosMoved = false;
        this.zoomScaleX = 1;
        this.zoomScaleY = 1;
        this.zoomStep = 0.05;
        this.offsetX = 0;
        this.offsetY = 0;
        this.data = new MapDataManager();
    }

    get showLegend() {
        return this._showLegend;
    }

    set showLegend(show) {
        this._showLegend = show;
        this.Refresh();
    }

    get showConnect() {
        return this._showConnect;
    }

    set showConnect(show) {
        this._showConnect = show;
        this.Refresh();
    }

    CreateMap(template, jsonData) {
        // 解析数据，创建井柱
        if (jsonData) {
            this.data.Parse(jsonData);
        }

        if (template) {
            for(const setting of template) {
                if (setting.type === 'MapSetting') {
                    this.InitMapSettings(setting);
                } else if (setting.type === 'WellSetting') {
                    for(const wellData of this.data.wells) {
                        this.AddWellDisplay(new WellDisplay(wellData, setting));
                    }
                }
            }
        }
    }

    InitMapSettings(template) {
        // 初始化图的大小
        const width = template.mapWidth;
        const height = template.mapHeight;

        this.width = width;
        this.height = height;
        this.mapWidth = width - this.leftMargin - this.rightMargin - this.borderLineWidth;
        this.mapHeight = height - this.topMargin - this.bottomMargin - this.borderLineWidth;

        [this.canvasWidth, this.canvasHeight] = CalcCanvasSize();

        // 创建 buffer 图层
        //this.root.style.width = width + 'px';
        //this.root.style.height = height + 'px';
        this.bufferLayer = this.CreateLayer('buffer', 99);
        // this.layers.push(this.bufferLayer);

        this.scrollWidth = width;
        this.scrollHeight = height;
    }

    CreateLayer(name, zIndex) {
        const canvas = document.createElement('canvas');
        canvas.id = name;
        canvas.style.backgroundColor = 'transparent';
        canvas.style.zIndex = zIndex;
        canvas.style.position = 'absolute';

        this.root.appendChild(canvas);
        return new MapLayer(new DrawingPort(canvas, this.canvasWidth, this.canvasHeight), name);
    }

    AddWellDisplay(well) {
        well.AdjustLayout();
        well.SetParentMap(this);
        this.wellDisplays.push(well);
    }

    Draw() {

    }

    UpdateCanvasSize() {
        [this.canvasWidth, this.canvasHeight] = CalcCanvasSize();
        for(const layer of this.layers) {
            layer.dp.canvasWidth = this.canvasWidth;
            layer.dp.canvasHeight = this.canvasHeight;
            layer.dp.UpdateScale();
        }
        this.bufferLayer.dp.canvasWidth = this.canvasWidth;
        this.bufferLayer.dp.canvasHeight = this.canvasHeight;
        this.bufferLayer.dp.UpdateScale();
     }

    Refresh() {
        for(const layer of this.layers) {
            layer.dp.ClearCanvas();
        }
        this.Draw();
    }

    ScrollTo(x, y) {
        this.offsetX = x;
        this.offsetY = y

        for(const layer of this.layers) {
            layer.dp.offsetX = x;
            layer.dp.offsetY = y;
        }
    }

    WellPosMoved() {
    }

    Map2Pixcel(x, y) {
        return [(x+this.leftMargin)*this.zoomScaleX+this.offsetX, (y+this.topMargin)*this.zoomScaleY+this.offsetY];
    }

    Pixcel2Map(x, y) {
        return [(x-this.offsetX)/this.zoomScaleX-this.leftMargin,(y-this.offsetY)/this.zoomScaleY-this.topMargin];
    }

    ScaleWindowPoint(x, y) {
        const scaleX = this.zoomScaleX;
        const scaleY = this.zoomScaleY;
        return [(x-this.offsetX)/scaleX-this.leftMargin,(y-this.offsetY)/scaleY-this.topMargin];
    }

    MapWindowPoint(x, y) {
        return [x-this.leftMargin*this.zoomScaleX,y-this.topMargin*this.zoomScaleY];
    }

    DrawFocusRect(rect) {
        const dp = this.bufferLayer.dp;

        dp.ClearCanvas();
        dp.BeginPaint();

        const ctx = dp.context;

        // let [clipX0, clipY0] = this.Map2Pixcel(0, 0);
        // let [clipX1, clipY1] = this.Map2Pixcel(this.mapWidth+this.leftMargin, this.mapHeight+this.topMargin);
        // ctx.beginPath();
        // ctx.rect(clipX0, clipY0, clipX1-clipX0, clipY1-clipY0);
        // ctx.clip();

        ctx.translate(this.leftMargin*this.zoomScaleX, this.topMargin*this.zoomScaleY);
        ctx.setLineDash([2,2]);
        ctx.strokeRect(rect.left, rect.top, rect.width, rect.height);

        dp.EndPaint();
    }

    MouseMove(e) {
        let [x, y] = this.ScaleWindowPoint(e.offsetX, e.offsetY);
        if (this.mouseDown && this.zoomRect) {
            this.movePrev = new Point(x, y);

            [this.zoomEnd.x, this.zoomEnd.y] = this.MapWindowPoint(e.offsetX, e.offsetY);

            this.DrawFocusRect(MakeRect(this.zoomBegin, this.zoomEnd));

            // this.DrawFocusRect(MakeRect(this.moveBegin, this.movePrev));
        } else if (this.mouseDown && this.currentWell != null) {
            const moveX = x - this.movePrev.x;
            const moveY = y - this.movePrev.y;

            const wellPos = this.currentWell.GetWellPos();
            wellPos.x += moveX;
            wellPos.y += moveY;

            this.currentWell.SetWellPos(wellPos.x, wellPos.y);
            this.Refresh();
            this.movePrev = new Point(x, y);

            this.wellPosMoved = true;
        }
    }

    MouseUp() {
        this.mouseDown = false;
        if (this.zoomRect) {
            this.bufferLayer.dp.ClearCanvas();
            this.DoZoomRect();
        } else if (this.wellPosMoved) {
            this.WellPosMoved();
            this.wellPosMoved = false;
        }
    }

    MouseDown(e) {
        let [x, y] = this.ScaleWindowPoint(e.offsetX, e.offsetY);
        this.mouseDown = true;
        this.currentWell = null;
        this.movePrev = null;

        this.zoomBegin = null;
        this.zoomEnd = null;

        if (this.zoomRect) {
            this.moveBegin = new Point(x, y);
            this.movePrev = new Point(x, y);

            let [x1, y1] = this.MapWindowPoint(e.offsetX, e.offsetY);
            this.zoomBegin = new Point(x1, y1);
            this.zoomEnd = new Point(x1, y1);
            // console.log(this.zoomBegin, this.zoomEnd);
        } else {
            for(let well of this.wellDisplays) {
                if (well.HitTest(x, y)) {
                    this.currentWell = well;
                    this.movePrev = new Point(x, y);
                    break;
                }
            }
        }
    }

    ScalePoint(x, y) {
        if (this.layers.length <= 0) {
            return [x, y];
        }
        return this.layers[0].ScalePoint(x, y);
    }

    UpdateScale() {
        for(const layer of this.layers) {
            layer.dp.UpdateScale();
        }
        this.bufferLayer.dp.UpdateScale();
    }

    DrawTitle(dp) {
        const ctx = dp.context;
        ctx.save();
        ctx.font = this.titleFont;
        ctx.textAlign = "center";
        ctx.textBaseline = "top";
        ctx.fillStyle = "Black";

        ctx.fillText(this.title, this.mapWidth/2, 0);
        ctx.restore();
    }

    DrawEditorInfo(dp) {
        const ctx = dp.context;
        ctx.save();

        ctx.font = this.userInfoFont;
        ctx.textAlign = "right";
        ctx.textBaseline = "top";
        ctx.fillStyle = "Black";

        const userInfo = `编图人: ${this.editUser}  制图人: ${this.makeUser}  审核人: ${this.verifyUser}  `;
        ctx.fillText(userInfo, this.mapWidth + this.leftMargin, this.topMargin + this.mapHeight + 8);

        ctx.restore();
    }

    DrawLegend(dp) {
        const ctx = dp.context;
        ctx.save();

        const rectHeight = 30;
        const rectWidth = 60;
        const space = 15;
        const left = 15;
        const top = this.mapHeight - 60;

        // 油层
        ctx.font = "12px 宋体";
        ctx.textAlign = "center";
        ctx.textBaseline = "top";

        ctx.lineWidth = 1;
        ctx.strokeStyle = "Black";
        ctx.fillStyle = "Red";
        let rectLeft = left;
        let rectTop = top;
        ctx.fillRect(rectLeft, rectTop, rectWidth, rectHeight);
        ctx.beginPath();
        ctx.rect(rectLeft, rectTop, rectWidth, rectHeight);
        ctx.stroke();

        ctx.fillStyle = "Black";
        ctx.fillText("油层", rectLeft + rectWidth/2, rectHeight + rectTop + 4);

        // 水层
        ctx.fillStyle = "Aquamarine";
        rectLeft += rectWidth + space;
        ctx.fillRect(rectLeft, rectTop, rectWidth, rectHeight);
        ctx.beginPath();
        ctx.rect(rectLeft, rectTop, rectWidth, rectHeight);
        ctx.stroke();

        ctx.fillStyle = "Black";
        ctx.fillText("水层", rectLeft + rectWidth/2, rectHeight + rectTop + 4);

        // 夹层
        ctx.fillStyle = "Silver";
        rectLeft += rectWidth + space;
        ctx.fillRect(rectLeft, rectTop, rectWidth, rectHeight);
        ctx.beginPath();
        ctx.rect(rectLeft, rectTop, rectWidth, rectHeight);
        ctx.stroke();

        ctx.fillStyle = "Black";
        ctx.fillText("夹层", rectLeft + rectWidth/2, rectHeight + rectTop + 4);

        // 图例
        ctx.font = "20px 隶书";
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";
        ctx.fillStyle = "Black";

        ctx.fillText("图   例", (rectLeft + rectWidth + left)/2, rectTop - 12);

        ctx.restore();
    }

    DrawBorder(dp) {
        const ctx = dp.context;
        ctx.save();
        ctx.strokeStyle = "Black";
        ctx.lineWidth = 1;

        ctx.strokeRect(this.leftMargin, this.topMargin, this.mapWidth, this.mapHeight);
        ctx.restore();
    }

    ZoomIn() {
        this.ZoomByCenter(this.zoomScaleX + this.zoomStep, this.zoomScaleY + this.zoomStep)
    }

    ZoomOut() {
        this.ZoomByCenter(this.zoomScaleX - this.zoomStep, this.zoomScaleY - this.zoomStep)
    }

    ZoomByCenter(x, y) {
        if (x > 0 && y > 0) {
            const x0 = this.zoomScaleX;
            const y0 = this.zoomScaleY;

            this.zoomScaleX = x;
            this.zoomScaleY = y;

            this.root.style.width = this.width * this.zoomScaleX + 'px';
            this.root.style.height = this.height * this.zoomScaleY + 'px';

            for(const layer of this.layers) {
                layer.ZoomBy(x, y);
            }

            const scrollbar = document.querySelector("#fence_scrollbar");
            if (null != scrollbar) {
                // 之前屏幕中心
                const screenCenterOldX = (this.canvasWidth/2 - this.offsetX)/x0;
                const screenCenterOldY = (this.canvasHeight/2 - this.offsetY)/y0;

                // 目前屏幕中心
                const screenCenterX = (this.canvasWidth/2 - this.offsetX)/this.zoomScaleX;
                const screenCenterY = (this.canvasHeight/2 - this.offsetY)/this.zoomScaleY;

                // 移动距离
                const offsetX = (screenCenterOldX - screenCenterX) * this.zoomScaleX;
                const offsetY = (screenCenterOldY - screenCenterY) * this.zoomScaleY;

                scrollbar.firstChild.scrollBy(offsetX, offsetY);
            }

            this.Refresh();
            // this.LogSizeInfo();
        }
    }

    ZoomBy(x, y, refresh = true) {
        if (x > 0 && y > 0) {
            this.zoomScaleX = x;
            this.zoomScaleY = y;

            this.root.style.width = this.width * this.zoomScaleX + 'px';
            this.root.style.height = this.height * this.zoomScaleY + 'px';

            for(const layer of this.layers) {
                layer.ZoomBy(x, y);
            }
            if (refresh) {
                this.Refresh();
            }
        }
    }

    LogSizeInfo() {
        console.log('canvas size2: ', this.canvasWidth, this.canvasHeight);
        console.log('scale ratio :', this.zoomScaleX, this.zoomScaleY);
        console.log('map size :', this.width, this.height);
        console.log('scaled map :', this.width*this.zoomScaleX, this.height*this.zoomScaleY);
        console.log('scroll size:', this.root.style.width, this.root.style.height);
    }

    ZoomFit() {
        this.UpdateScrollBarSizes();
        this.UpdateCanvasSize();

        // 扣除滚动条宽高
        const clientWidth = this.scrollWidth - 30;
        const clientHeight = this.scrollHeight - 30;

        const ratioX = clientWidth/(this.width+5);
        const ratioY = clientHeight/(this.height+5);
        const ratio = Math.min(ratioX, ratioY);

        this.ZoomBy(ratio, ratio);

        // this.LogSizeInfo();
    }

    ZoomRect() {
        if (this.zoomRect) {
            this.root.style.cursor = 'auto';
            this.zoomRect = false;
        } else {
            this.root.style.cursor = 'se-resize';
            this.zoomRect = true;
        }
    }

    DoZoomRect() {
        const width = Math.abs(this.moveBegin.x - this.movePrev.x) * this.zoomScaleX;
        const height = Math.abs(this.moveBegin.y - this.movePrev.y) * this.zoomScaleY;

        const ratioX = this.canvasWidth / width;
        const ratioY = this.canvasHeight / height;

        const ratio = Math.min(ratioX, ratioY);
        this.ZoomBy(this.zoomScaleX*ratio, this.zoomScaleX*ratio, false);

        // 窗口滚动到缩放中心
        const scrollbar = document.querySelector("#fence_scrollbar");
        if (null != scrollbar) {
            // 缩放选择框的中心
            const selectCenter =  CenterPoint(this.moveBegin, this.movePrev);
            selectCenter.x += this.leftMargin;
            selectCenter.y += this.topMargin;
            // 目前屏幕中心
            const screenCenterX = (this.canvasWidth/2 - this.offsetX)/this.zoomScaleX;
            const screenCenterY = (this.canvasHeight/2 - this.offsetY)/this.zoomScaleY;
            // 移动距离
            const offsetX = (selectCenter.x - screenCenterX) * this.zoomScaleX;
            const offsetY = (selectCenter.y - screenCenterY) * this.zoomScaleY;

            scrollbar.firstChild.scrollBy(offsetX, offsetY);
        }
        this.zoomRect = false;
        this.root.style.cursor = 'auto';
        this.Refresh();
    }

    UpdateScrollBarSizes() {
        const scrollbar = document.querySelector('#fence_scrollbar');
        const rootRect = scrollbar.getBoundingClientRect();

        // 扣除滚动条宽度
        const clientWidth = window.innerWidth - rootRect.left - 25;
        const clientHeight = window.innerHeight - rootRect.top - 50;

        this.root.style.width = clientWidth +'px';
        this.root.style.height = clientHeight+'px';

        scrollbar.style.width = clientWidth + 'px';
        scrollbar.style.height = clientHeight + 'px';
        scrollbar.firstChild.style.width = clientWidth + 'px';
        scrollbar.firstChild.style.height = clientHeight + 'px';

        this.scrollWidth = clientWidth;
        this.scrollHeight = clientHeight;
    }

    GetVisibleRect() {
        const left = (-this.offsetX)/this.zoomScaleX + this.leftMargin;
        const top = (-this.offsetY)/this.zoomScaleY + this.topMargin;

        const width = this.scrollWidth/this.zoomScaleX;
        const height = this.scrollHeight/this.zoomScaleY;
        return new Rect(left, top, width, height);
    }
}

class SectionMap extends MapBase{
    constructor(root,template = null, jsonData = null) {
        super(root);

        this.title = "栅状图";
        this.wellLayer = null;
        this.connLayer = null;
        this.links = [];
        this.pinchLength = 2;   // 序号从 1 开始，1/2 1/4 1/3 Lh/H Lh/(h+1)

        if (template && jsonData) {
            this.CreateMap(template, jsonData);
        }
    }

    CreateMap(template, jsonData) {
        super.CreateMap(template, jsonData);

        if (template) {
            for(const setting of template) {
                if (setting.type === 'MapSetting') {
                    this.pinchLength = setting.pinchLength;
                }
            }
        }

        this.connLayer = this.CreateLayer('Conn', '1');
        this.layers.push(this.connLayer);

        this.wellLayer = this.CreateLayer('Well', '2');
        this.layers.push(this.wellLayer);
    }

    Draw() {
        this.DrawSection();

        if (this.showConnect) {
            this.DrawLink();
        }
    }

    DrawSection() {
        const dp = this.wellLayer.dp;
        const ctx = dp.context;

        dp.BeginPaint();

        this.DrawTitle(dp);
        this.DrawBorder(dp);
        this.DrawEditorInfo(dp);

        ctx.translate(this.leftMargin, this.topMargin);

        ctx.beginPath();
        ctx.rect(0, 0, this.mapWidth, this.mapHeight);
        ctx.clip();

        const visibleRect = this.GetVisibleRect();
        for(const well of this.wellDisplays) {
            if (visibleRect.HasIntersection(well.GetRect())) {
                const wellPos = well.GetWellPos();

                let rectWell = visibleRect.Clone();
                rectWell.OffsetRect(-wellPos.x, -wellPos.y);

                well.Draw(dp, rectWell);
            }
        }

        if (this.showLegend) {
            this.DrawLegend(dp);
        }

        dp.EndPaint();
    }

    DrawLink() {
        const dp = this.connLayer.dp;
        dp.BeginPaint();

        const ctx = dp.context;
        ctx.translate(this.leftMargin, this.topMargin);

        ctx.beginPath();
        ctx.rect(0, 0, this.mapWidth, this.mapHeight);
        ctx.clip();

        const visibleRect = this.GetVisibleRect();
        // for(const well of this.wellDisplays) {
        //     if (visibleRect.HasIntersection(well.GetRect())) {
        //         well.DrawLink(dp);
        //     }
        // }

        for(const link of this.links) {
            if (visibleRect.HasIntersection(link.GetRect())) {
                link.Draw(dp);
            }
        }
        dp.EndPaint();
    }

    AutoLink(srcWellId, tarWellId) {
        const wellCount = this.wellDisplays.length;
        if (Math.min(srcWellId, tarWellId) < 0 || Math.max(srcWellId, tarWellId) >= wellCount) {
            return;
        }

        const srcWell = this.wellDisplays[srcWellId];
        const tarWell = this.wellDisplays[tarWellId];

        const srcTop = srcWell.minDepth;
        const srcBot = srcWell.maxDepth;

        const tarTop = tarWell.minDepth;
        const tarBot = tarWell.maxDepth;

        const srcData = srcWell.GetData().GetSandData();
        const tarData = tarWell.GetData().GetSandData();

        if (null === srcData || null === tarData) {
            return;
        }

        // 按层整理数据
        let srcDataMap = {};
        let tarDataMap = {};
        for(const d of srcData.layers) {
            const layerName = d.name;
            if (layerName in srcDataMap) {
                srcDataMap[layerName].push(d);
            } else {
                srcDataMap[layerName] = [d];
            }
        }

        for(const d of tarData.layers) {
            const layerName = d.name;
            if (layerName in tarDataMap) {
                tarDataMap[layerName].push(d);
            } else {
                tarDataMap[layerName] = [d];
            }
        }

        let srcConn = [];
        let tarConn = [];

        for(const layer in srcDataMap) {

            let srcSegSet = new SegmentSet(layer, srcWell);
            let tarSegSet = new SegmentSet(layer, tarWell);

            const segs = srcDataMap[layer];
            for(const srcSeg of segs) {
                if (srcSeg.topDepth < srcTop) {
                    continue;
                }
                if (srcSeg.botDepth > srcBot) {
                    break;
                }
                const top1 = srcSeg.topDepth - srcSeg.refrenceTop;
                const bot1 = srcSeg.botDepth - srcSeg.refrenceTop;
                if (layer in tarDataMap) {

                    const tarSegs = tarDataMap[layer];
                    for(const tarSeg of tarSegs) {
                        if (tarSeg.topDepth < tarTop) {
                            continue;
                        }
                        if (tarSeg.botDepth > tarBot) {
                            break;
                        }

                        const factor = (srcSeg.refrenceBot - srcSeg.refrenceTop)/(tarSeg.refrenceBot-tarSeg.refrenceTop);
                        // const top2 = (tarSeg.topDepth - tarSeg.refrenceTop);
                        // const bot2 = (tarSeg.botDepth - tarSeg.refrenceTop);
                        const top2 = (tarSeg.topDepth - tarSeg.refrenceTop) * factor;
                        const bot2 = (tarSeg.botDepth - tarSeg.refrenceTop) * factor;

                        if (bot2 > top1 && bot1 > top2) {
                            if (srcSegSet.segments.indexOf(srcSeg) === -1) {
                                srcSegSet.segments.push(srcSeg);    // COPY ?
                                srcConn.push(srcSeg);
                            }
                            if (tarSegSet.segments.indexOf(tarSeg) === -1) {
                                tarSegSet.segments.push(tarSeg);    // COPY ?
                                tarConn.push(tarSeg);
                            }
                        }
                    }
                }
            }
            if (srcSegSet.segments.length > 0) {
                const link = new SegmentLink(layer, srcSegSet, tarSegSet, this.pinchLength);
                this.links.push(link);
                srcWell.GetLinkGroup().AddLink(link);
                tarWell.GetLinkGroup().AddLink(link);
            }
        }

        // 创建尖灭
        let fnLose = (segs, conn, lose, top, bot) => {
            for(const seg of segs) {
                if (seg.topDepth < top) {
                    continue;
                }
                if (seg.botDepth > bot) {
                    break;
                }
                if (conn.indexOf(seg) === -1) {
                    lose.push(seg);
                }
            }
        };

        let srcLoses = [];
        let tarLoses = [];

        for(const layer in srcDataMap) {
            fnLose(srcDataMap[layer], srcConn, srcLoses, srcTop, srcBot);
        }
        for(const layer in tarDataMap) {
            fnLose(tarDataMap[layer], tarConn, tarLoses, tarTop, tarBot);
        }

        // 分层数据，用于辅助绘制尖灭
        const srcStratumData = srcWell.GetData().GetStratumData();
        const tarStratumData = tarWell.GetData().GetStratumData();

        let srcStratumMap = {};
        let tarStratumMap = {};

        for(const d of srcStratumData.layers) {
            const layerName = d.name;
            srcStratumMap[layerName] = d;
        }
        for(const d of tarStratumData.layers) {
            const layerName = d.name;
            tarStratumMap[layerName] = d;
        }

        for(const seg of srcLoses) {
            const layer = seg.name;
            const stratum = seg.stratum;

            if (!(stratum in srcStratumMap) || !(stratum in tarStratumMap)) {
                continue;
            }

            let srcSegSet = new SegmentSet(layer, srcWell);
            let tarSegSet = new SegmentSet(layer, tarWell);

            srcSegSet.segTop = srcStratumMap[stratum].topDepth;
            srcSegSet.segBot = srcStratumMap[stratum].botDepth;

            tarSegSet.segTop = tarStratumMap[stratum].topDepth;
            tarSegSet.segBot = tarStratumMap[stratum].botDepth;

            srcSegSet.segments.push(seg);

            const link = new SegmentLink(layer, srcSegSet, tarSegSet, this.pinchLength);
            this.links.push(link);
            srcWell.GetLinkGroup().AddLink(link);
        }

        for(const seg of tarLoses) {
            const layer = seg.name;
            const stratum = seg.stratum;

            if (!(stratum in srcStratumMap) || !(stratum in tarStratumMap)) {
                continue;
            }

            let srcSegSet = new SegmentSet(layer, srcWell);
            let tarSegSet = new SegmentSet(layer, tarWell);

            srcSegSet.segTop = srcStratumMap[stratum].topDepth;
            srcSegSet.segBot = srcStratumMap[stratum].botDepth;

            tarSegSet.segTop = tarStratumMap[stratum].topDepth;
            tarSegSet.segBot = tarStratumMap[stratum].botDepth;

            tarSegSet.segments.push(seg);

            const link = new SegmentLink(layer, srcSegSet, tarSegSet, this.pinchLength);
            this.links.push(link);
            tarWell.GetLinkGroup().AddLink(link);
        }

        srcWell.GetLinkGroup().UpdateSegments();
        tarWell.GetLinkGroup().UpdateSegments();
    }

    RemoveLinks() {
        this.links = [];
        for(const well of this.wellDisplays) {
            well.GetLinkGroup().ClearAll();
        }
    }

    SortLinks() {
        this.links.sort(function(a, b) {return a.SortBy() - b.SortBy()});
    }

    WellPosMoved() {
        this.SortLinks();
        this.Refresh();
    }
}

class FenceMap extends SectionMap {
    constructor(root, template = null, jsonData = null) {
        super(root);
        this._rotateAngle = 0;

        if (template && jsonData) {
            this.CreateMap(template, jsonData);
        }
    }

    get rotateAngle() {
        return this._rotateAngle;
    }

    set rotateAngle(angle) {
        this._rotateAngle = angle;
        this.RotateWells(angle);
        this.SortLinks();
        this.Refresh();
    }

    GetData() {
        return this.data;
    }

    CreateMap(template, jsonData) {
        super.CreateMap(template, jsonData);

        this.RotateWells(0);
        this.LinkFence();
        this.ZoomFit();
    }

    RotateWells(rotate) {
        const wellCount = this.wellDisplays.length;

        if (wellCount === 0) {
            return;
        }

        const centerWell = this.wellDisplays[0];

        // 统计井的最大高度
        let maxHeight = 0;
        for(let i = 0; i < wellCount; i++) {
            let height = this.wellDisplays[i].GetRect().height;
            if (height > maxHeight)
                maxHeight = height;
        }

        const width = this.mapWidth-centerWell.GetWidth();
        const height = this.mapHeight;
        const centerX = Math.floor(width/2);
        const centerY = Math.floor(height/2) - maxHeight/2;
        const radiusX = width/2;
        const radiusY = height/2 - maxHeight/2;
        const angle = Math.PI * 2 / (wellCount - 1);
        const rotate0 = Math.PI * rotate/180.0;

        for(let i = 0; i < wellCount; i++) {
            let x = centerX;
            let y = centerY;

            if (i > 0) {
                x = centerX + Math.floor(radiusX * Math.cos(rotate0 + angle * (i - 1)));
                y = centerY - Math.floor(radiusY * Math.sin(rotate0 + angle * (i - 1)));
            }

            this.wellDisplays[i].SetWellPos(x, y);
        }
    }

    LinkFence() {
        for(let i = 1; i <this.wellDisplays.length; i++) {
            this.AutoLink(0, i);
            if (i+1 === this.wellDisplays.length) {
                this.AutoLink(i, 1);
            } else {
                this.AutoLink(i, i+1);
            }
        }
        this.SortLinks();
    }
}

class MapLayer {
    constructor(dp, name) {
        this.dp = dp;
        this.name = name;
    }

    ClearRect(rect) {
        this.dp.ClearRect(rect);
    }

    EraseBackground() {
        this.dp.ClearCanvas();
    }

    ZoomBy(x, y) {
        if (x > 0 && y > 0) {
            this.dp.scaleX = x;
            this.dp.scaleY = y;
            this.dp.UpdateScale();
        }
    }

    ZoomByCenter(x, y) {
        const x0 = this.dp.scaleX;
        const y0 = this.dp.scaleY;

        this.ZoomBy(x, y);

        const deltX = x0 - x;
        const deltY = y0 - y;

        const offsetX = this.dp.canvasWidth * deltX / 2;
        const offsetY = this.dp.canvasHeight * deltY / 2;

        this.dp.translate(offsetX, offsetY);
    }

    ScalePoint(x, y) {
        return [Math.floor(x/this.dp.scaleX), Math.floor(y/this.dp.scaleY)];
    }
}

class DrawingPort{
    constructor(canvas, width, height) {
        this.canvas = canvas;
        this.context = canvas.getContext("2d");
        this.context.lineWidth = 1;
        this.canvasWidth = width;
        this.canvasHeight = height;
        this.scaleX = 1;
        this.scaleY = 1;
        this.offsetX = 0;
        this.offsetY = 0;

        this.UpdateScale();
    }

    UpdateScale() {
        this.canvas.width = Math.floor(this.canvasWidth*window.devicePixelRatio);
        this.canvas.height = Math.floor(this.canvasHeight*window.devicePixelRatio);
        this.canvas.style.width = this.canvasWidth + 'px';
        this.canvas.style.height = this.canvasHeight + 'px';
    }

    ClearCanvas() {
        this.canvas.width = this.canvas.width * 1.0;
    }

    ClearRect(rect) {
        this.context.clearRect(rect.left, rect.top, rect.width, rect.height);
    }

    BeginPaint() {
        this.context.save();

        this.context.translate(0.5,0.5);
        const ratio = window.devicePixelRatio;
        this.context.translate(this.offsetX*ratio, this.offsetY*ratio);
        this.context.scale(this.scaleX, this.scaleY);
        this.context.scale(ratio, ratio);
    }

    EndPaint() {
        this.context.restore();
    }
}

function mouseMove(e) {
    for(const map of maps) {
        map.MouseMove(e);
    }
}

function mouseDown(e) {
    for(const map of maps) {
        map.MouseDown(e);
    }
}

function mouseUp() {
    for(const map of maps) {
        map.MouseUp();
    }
}

function resizeEventHandler() {
    if (dpiScale !== window.devicePixelRatio) {
        for(const map of maps) {
            map.UpdateScale();
            map.Refresh();
        }
        dpiScale = window.devicePixelRatio;
    }
}

function scrollEventHandler() {
    const scrollbar = document.querySelector("#fence_scrollbar");
    const wrapView = scrollbar.firstChild;

    for(const map of maps) {
        map.ScrollTo(-wrapView.scrollLeft, -wrapView.scrollTop);
        map.Refresh();
    }
}

function wheelEventHandler(e) {
    e.preventDefault();

    const wrapView = GetScrollView();
    wrapView.scrollBy(0, e.deltaY);
}

function GetScrollView() {
    const scrollbar = document.querySelector("#fence_scrollbar");
    return scrollbar.firstChild;
}

// function CalcCanvasSize() {
//     const scrollbar = document.querySelector("#fence_scrollbar");
//     const rootRect = scrollbar.getBoundingClientRect();
//     const clientWidth = window.innerWidth - rootRect.left - 25;
//     const clientHeight = window.innerHeight - rootRect.top;
//     const scrollBarSize = 17;
//     return [clientWidth-scrollBarSize, clientHeight-scrollBarSize];
// }
function CalcCanvasSize() {
    const scrollbar = document.querySelector("#fence_scrollbar");
    const rootRect = scrollbar.getBoundingClientRect();

    const clientWidth = rootRect.width;
    const clientHeight = rootRect.height > 0 ? rootRect.height : 800;
    const scrollBarSize = 40;
    return [clientWidth-scrollBarSize, clientHeight-scrollBarSize];
}

function createFenceMap(container, template, jsonData) {
    const map = new FenceMap(container, template, jsonData);
    maps.push(map);

    container.addEventListener('mousemove', mouseMove);
    container.addEventListener('mousedown', mouseDown);
    container.addEventListener('mouseup', mouseUp);
    container.addEventListener('wheel', wheelEventHandler);
    window.addEventListener('resize', resizeEventHandler);
    GetScrollView().addEventListener('scroll', scrollEventHandler);
    return map;
}

function clearMap(container){
    container.innerHTML = '';
    maps = [];
}

export{
    DrawingPort,
    SectionMap,
    FenceMap,
    WellDisplay,
    DepthTrack,
    LogCurveTrack,
    WellLogCurve,
    WellLogFill,
    SandTrack,
    StratumTrack,
    PerfTrack,
    MapDataManager,
    createFenceMap,
    clearMap,
    base64ToFloat64Array
};